/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/jsx-props-no-spreading */
import { useMsal } from "@azure/msal-react";
import { ChangeEvent, useEffect, useState } from "react";
import { Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Prompt, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { format, isBefore } from "date-fns";

import {
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../../api/ApiClient";
import { ReactComponent as CheckIcon } from "../../assets/icons/Check.svg";
import { ReactComponent as ExpandIcon } from "../../assets/icons/Expand.svg";
import { ReactComponent as InformationIcon } from "../../assets/icons/Information.svg";
import { ReactComponent as InformationModal } from "../../assets/icons/InformationModal.svg";
import { ReactComponent as LessIcon } from "../../assets/icons/Less.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/Plus.svg";
import { ReactComponent as RecallIcon } from "../../assets/icons/Recall.svg";
import { ReactComponent as SuccessModal } from "../../assets/icons/SuccessModal.svg";
import Autocomplete from "../../components/Autocomplete";
import AutoCompleteClean from "../../components/AutoCompleteClean";
import Dialog from "../../components/Dialog";
import {
    ArrowRightIcon,
    DeleteIcon,
    EditIcon,
    PlusIconNoBorder,
    UserIcon,
    ViewIcon,
} from "../../components/Icons";
import InputLabelTextArea from "../../components/InputLabelTextArea";
import InputSelect from "../../components/InputSelect";
import {
    ContagemCargaHorariaEnum,
    ContagemCargaHorariaEnumLabel,
} from "../../model/Enums/ContagemCargaHorariaEnum";
import {
    PlanoAtividadeStatusEnum,
    PlanoAtividadeStatusEnumLabel,
} from "../../model/Enums/PlanoAtividadeStatusEnum";
import { Roles } from "../../model/Enums/RolesEnum";
import { Routes } from "../../model/Enums/RoutesEnum";
import {
    TipoHoraEnum,
    TipoHoraEnumLabel,
} from "../../model/Enums/TipoHoraEnum";
import SelectOption from "../../model/SelectOption";
import ActivityPlanBlocksService from "../../service/Docente/ActivityPlanBlocksService";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledBody,
    StyledCenterDiv,
    StyledFlexDiv,
    StyledSubTitle,
} from "../../styles/MainStyles";
import {
    StyledCard,
    StyledCardAvailableHours,
    StyledCardHour,
    StyledCardTeacher,
    StyledCardTitle,
    StyledDefaultButtonLink,
    StyledInformationPlan,
    StyledInformationPlanNotFound,
    StyledModalHeader,
    StyledSelectTeacherDiv,
    StyledTableActivityDiv,
    StyledTableActivityTd,
    StyledText,
    StyledTextPlan,
    StyledTimeDiv,
    StyledTitlePlan,
    StyledTopActivityCard,
    inputNumberHourStyles,
    tableConsultProfileStyles,
    disabledInputTypeHourStyle,
    StyledFlexDivSpaceBetween,
    StyledFlexDivAlignCenter,
    StyledSemesterDiv,
    StyledSemesterParagraph,
    StyledFlexDivWithGap,
    StyledValidity,
    StyledTitleHistoric,
    StyledHistoricInfoIcons,
    StyledPaddingLeft,
} from "../../styles/pages/AcademicActivityPlanStyles";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";
import { MASK_DATE, promptMessage } from "../../utils/constants";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import "./AcademicActivityPlan.css";
import AcademicActivityPlansItem, {
    getNumbersOption,
} from "./AcademicActivityPlansTypes";
import EditAcademicActivity from "./EditAcademicActivity";
import ModalDetailsAcademicActivity, {
    IModalDetailsAcademicActivityProps,
} from "./ModalDetailsAcademicActivity";
import AcademicActivityPlanHistoric, {
    IActivityPlanHistoric,
} from "./AcademicActivityPlanHistoric";
import ModalJustifyPlan from "./ModalJustifyPlan";
import AcademicActivityPlanHeader from "./AcademicActivityPlanHeader";
import { VigenciaPlanoAtividade } from "../../model/dto/VigenciaPlanoAtividade";
import { StyledIconInfo } from "../../styles/pages/AcademicActivityPlan/ModalDetailsAcademicActivityStyles";
import AcademicActivityPlanService from "../../service/Docente/AcademicActivityPlanService";
import ProfessorService from "../../service/Docente/ProfessorService";
import ModalRequestJustificationEndTach from "./ModalRequestJustificationEndTach";
import AcademicActivityPlanEndHistoric from "./AcademicActivityPlanEndHistoric";

type TypeProfessorData = {
    docenteID: number;
    matriculaAdp: string;
    nome: string;
    cargaHorariaTotalCalculado: number;
    naoLetivaBase: number;
    horaNaoLetivaEventual: number;
    horaNaoLetivaSubstituicao: number;
};

type TypeExtraProfessorData = {
    vigencia: string;
    dataVigenciaInicio: string;
    dataVigenciaFim: string;
    planoAtividadeDocenteId: number;
};

const initialModalProps: IActivityPlanHistoric = {
    open: false,
    teachingActivityPlanId: 0,
};

const endPlanHistoryModalProps: IActivityPlanHistoric = {
    open: false,
    teachingActivityPlanId: 0,
};

const initialWorkloadHistoricExtraData: TypeExtraProfessorData = {
    vigencia: "",
    dataVigenciaInicio: "",
    dataVigenciaFim: "",
    planoAtividadeDocenteId: 0,
};

type StudentInfo = {
    value: string;
    label: string;
    studentId?: string;
};

type ErrorState = {
    hasError: boolean;
    message: string;
    title: string;
};

function AcademicActivityPlan() {
    const { BtnPrimary, BtnOutlinePrimary } = ButtonStyles;
    const { StyledImportButton, StyledModalTitle, StyledModalText } =
        UploadFileStyles;
    const [editTach, setEditTach] = useState(false);

    function getNewGetWorkLoadValue() {
        return {
            docenteId: 0,
            letivaBase: 0,
            horaLetivaEventual: 0,
            horaLetivaSubstituicao: 0,
            naoLetivaBase: 0,
            horaNaoLetivaEventual: 0,
            horaNaoLetivaSubstituicao: 0,
            cargaHorariaTotal: 0,
            dataUpdate: "",
        };
    }

    function getNewStudentsFormValue() {
        return [
            {
                estudanteId: 0,
                centroResultadoId: 0,
                nome: "",
                cpf: "",
                passaporte: "",
                matricula: "",
            },
        ];
    }

    function getNewActivityPlanItens() {
        return {
            activity: {},
            campus: {},
            coverage: {},
            detailing: {},
            hour: {},
            hoursBookings: {},
            id: undefined,
            students: [],
            typeHour: "",
            dataVigenciaInicio: undefined,
            dataVigenciaFim: undefined,
            workloadValid: {},
            tableIndex: -1,
        };
    }

    const { instance: msalAplication } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();
    const location = useLocation();

    const [selectedActivity, setSelectedActivity] = useState<any[]>([]);
    const [selectedCampus, setSelectedCampus] = useState<any[]>([]);
    const [selectedCoverage, setSelectedCoverage] = useState<any[]>([]);
    const [selectedStudentsId, setSelectedStudentsId] = useState<any[]>([]);
    const [studentsFormFullFilled, setStudentsFormFullFilled] =
        useState<boolean>(false);
    const [selectedStudentsName, setSelectedStudentsName] = useState<any[]>([]);
    const [selected, setSelected] = useState<any[]>([]);
    const [teachers, setTeachers] = useState<any[]>([]);
    const [periods, setPeriods] = useState<any[]>([]);
    const [timeType, setTimeType] = useState<any[]>([]);
    const [selectTimeType, setSelectTimeType] = useState("2");
    const [timeTypeResponse, setTimeTypeResponse] = useState<any[]>([]);
    const [periodsValidity, setPeriodsValidity] = useState<any[]>([]);
    const [getPeriodsValue, setGetPeriodsValue] = useState<any[]>([]);
    const [getPeriodsValidityValue, setGetPeriodsValidityValue] = useState<
        any[]
    >([]);
    const [selectPeriods, setSelectPeriods] = useState("");
    const [selectedPeriod, setSelectedPeriod] = useState("");
    const [getTeachers, setGetTeachers] = useState<any[]>([]);
    const [getActivitiesValue, setGetActivitiesValue] = useState<any[]>([]);
    const [getCampusValue, setGetCampusValue] = useState<any[]>([]);
    const [getCoverageValue, setGetCoverageValue] = useState<any[]>([]);
    const [getStudentsValue, setGetStudentsValue] = useState<any[]>([]);
    const [selectTeachers, setSelectTeachers] = useState<any>();
    const [selectCampus, setSelectCampus] = useState<any>();
    const [selectCoverage, setSelectCoverage] = useState<any>();
    const [selectActivity, setSelectActivity] = useState<any>();
    const [workloadBase, setWorkloadBase] = useState(0);
    const [workloadEventual, setWorkloadEventual] = useState(0);
    const [workloadSubstituicao, setWorkloadSubstituicao] = useState(0);
    const [workloadOriginalBase, setWorkloadOriginalBase] = useState(0);
    const [workloadHistoric, setWorkloadHistoric] = useState<TypeProfessorData>(
        {
            docenteID: 0,
            matriculaAdp: "",
            nome: "",
            cargaHorariaTotalCalculado: 0,
            naoLetivaBase: 0,
            horaNaoLetivaEventual: 0,
            horaNaoLetivaSubstituicao: 0,
        }
    );
    const [workloadHistoricExtraData, setWorkloadHistoricExtraData] =
        useState<TypeExtraProfessorData>(initialWorkloadHistoricExtraData);
    const [endPlanHistoricExtraData, setEndPlanHistoricExtraData] =
        useState<TypeExtraProfessorData>(initialWorkloadHistoricExtraData);
    const [workloadOriginalEventual, setWorkloadOriginalEventual] = useState(0);
    const [workloadOriginalSubstituicao, setWorkloadOriginalSubstituicao] =
        useState(0);
    const [
        horaNaoLetivaFlutuanteReservaBase,
        setHoraNaoLetivaFlutuanteReservaBase,
    ] = useState(0);
    const [
        horaNaoLetivaFlutuanteReservaEventual,
        setHoraNaoLetivaFlutuanteReservaEventual,
    ] = useState(0);
    const [
        horaNaoLetivaFlutuanteReservaSubstituicao,
        setHoraNaoLetivaFlutuanteReservaSubstituicao,
    ] = useState(0);
    const [showDialogCreateActivityPlan, setShowDialogCreateActivityPlan] =
        useState(false);
    const [showDialogWorkload, setShowDialogWorkload] = useState(false);
    const [showDialogNoHours, setShowDialogNoHours] = useState(false);
    const [showDialogActivityIncluded, setOpenViewActivity] = useState(false);
    const [showDialogEditActivity, setShowDialogEditActivity] = useState(false);
    const [showDialogTachHistoric, setShowDialogTachHistoric] = useState(false);
    const [showTableTachHistoric, setShowTableTachHistoric] = useState(false);
    const [isCreatePlan, setIsCreatePlan] = useState(false);
    const [activities, setActivities] = useState<any[]>([]);
    const [numberHours, setNumberHours] = useState<any[]>([]);
    const [selectNumberHours, setSelectNumberHours] = useState("");
    const [campus, setCampus] = useState<any[]>([]);
    const [covegage, setCoverage] = useState<any[]>([]);
    const [studentsId, setStudentsId] = useState<any[]>([]);
    const [studentsName, setStudentsName] = useState<any[]>([]);
    const [textArea, setTextArea] = useState("");
    const [table, setTable] = useState<AcademicActivityPlansItem[]>([]);
    const [activityPlan, setActivityPlan] = useState<any[]>([]);
    const [modalJustify, setModalJustify] = useState(false);
    const [modalSucess, setModalSucess] = useState(false);

    const [workloadValue, setGetWorkloadValue] = useState(
        getNewGetWorkLoadValue()
    );
    const [hoursUsed, setHoursUsed] = useState(0);
    const [showTableActivities, setShowTableActivities] = useState(true);
    const [showTableHistoric, setShowTableHistoric] = useState(true);
    const [showDialogActivityRemoved, setShowDialogActivityRemoved] =
        useState(false);
    const [modalError, setModalError] = useState(false);
    const [isStudents, setIsStudents] = useState(false);
    const [
        showDialogActivityPlanSendToAprove,
        setShowDialogActivityPlanSendToAprove,
    ] = useState(false);
    const [showDialogDraft, setShowDialogDraft] = useState(false);

    const [studentsForm, setStudentsForm] = useState(getNewStudentsFormValue());
    const [, setUrlResponse] = useState();
    const [indexTable, setIndexTable] = useState<number>(0);
    const [teachingActivity, setTeachingActivity] = useState<any>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [activityTooltip, setActivityTooltip] = useState("");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [coverageTooltip, setCoverageTooltip] = useState("");
    const [mandatoryDetailing, setMandatoryDetailing] = useState("");
    const [finalDate, setFinalDate] = useState("");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [initialDate, setInitialDate] = useState("");
    const [validity, setValidity] = useState<any>();
    const [showModalError, setShowModalError] = useState(false);
    const [modalErrorText, setModalErrorText] = useState("");
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [modalErrorStudentAssociado, setModalErrorStudentAssociado] =
        useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [disabledCriarTach, setDisabledCriarTach] = useState(false);
    const [indexModal, setIndexModal] = useState<number | null>(null);
    const [currentStatusActivityPlan, setCurrentStatusActivityPlan] =
        useState<any>(null);
    const [previousStatusActivityPlan, setPreviousStatusActivityPlan] =
        useState<any>(null);

    const [currentActivity, setCurrentActivity] =
        useState<AcademicActivityPlansItem>(getNewActivityPlanItens());
    const [
        modalDetailsAcademicActivityProps,
        setModalDetailsAcademicActivityProps,
    ] = useState<IModalDetailsAcademicActivityProps>(initialModalProps);
    const [
        modalAcademicActivityPlanHistoricProps,
        setModalAcademicActivityPlanHistoricProps,
    ] = useState<IActivityPlanHistoric>(initialModalProps);
    const [
        modalAcademicActivityPlanEndPlanHistoricProps,
        setModalAcademicActivityPlanEndPlanHistoricProps,
    ] = useState<IActivityPlanHistoric>(endPlanHistoryModalProps);

    const [isBlockPeriod, setIsBlockPeriod] = useState(false);
    const [showDialogJustifyEndTach, setShowDialogJustifyEndTach] =
        useState<boolean>(false);
    const [selectedPlan, setSelectedPlan] = useState<number>(0);
    const [error, setError] = useState<ErrorState>({
        hasError: false,
        message: "",
        title: "",
    });

    const user = GenericUtils.getUser();
    const pathLocation = location.pathname.split("/");

    const getRole = () => {
        return !!user?.listaFuncionalidades?.find(
            (item: any) =>
                item?.mnemonico === Roles.EDITAR_PLANO_ATIVIDADE_DOCENTE
        );
    };

    const getRoleConsult = () => {
        return !!user?.listaFuncionalidades?.find(
            (item: any) => item?.mnemonico === Roles.VISUALIZAR_PLANO_ATIVIDADE
        );
    };

    const validaDataVigenciaInicioPlano = (): string => {
        const vigenciaPlanoatividade =
            (getPeriodsValidityValue[0] as VigenciaPlanoAtividade) ||
            (validity as VigenciaPlanoAtividade);

        const dataInicioVigencia = new Date(
            `${vigenciaPlanoatividade.planoAtividadeDtInicio}T00:00:00`
        );

        return isBefore(dataInicioVigencia, new Date())
            ? format(new Date(), "yyyy-MM-dd")
            : vigenciaPlanoatividade.planoAtividadeDtInicio;
    };

    const isConsultProfile = !getRole() && getRoleConsult();
    const isMyConsultProfile =
        isConsultProfile &&
        user?.docente?.matriculaAdp === selectTeachers?.matriculaAdp;

    async function getActiveTeachers(
        totalHours?: boolean,
        name?: string,
        coordinationId?: string
    ) {
        const newTeachers = new Array<SelectOption>();
        const nameParm = name ? `&nome=${name}` : "";
        const coordinationIdParam = coordinationId
            ? `&matricula_coordenador=${coordinationId}`
            : "";
        const response = await axiosGetRequest(
            `/docente/v1/professores?_limit=500000&horasTotais=${totalHours}${nameParm}${coordinationIdParam}`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response?.data?.map((data: any) =>
                newTeachers.push({
                    value: data.matriculaAdp,
                    label: data.nome,
                })
            );

            setGetTeachers(response?.data);
            setTeachers(newTeachers);
        }
    }

    const desabilitarCargaHoraria = (teacher: any) => {
        return (
            teacher?.horaNaoLetivaEventual === 0 &&
            teacher?.horaNaoLetivaSubstituicao === 0 &&
            teacher?.naoLetivaBase === 0
        );
    };

    async function getCampus() {
        const newCampus = new Array<SelectOption>();

        const response = await axiosGetRequest(
            `/docente/v1/centros-resultado/atividades/${selectActivity?.atividadeId}/campus`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newCampus.push({
                    value: data,
                    label: data,
                })
            );

            setGetCampusValue(response.data);
            setCampus(newCampus);
        }
    }

    async function getCoverage() {
        const newCoverage = new Array<SelectOption>();

        const response = await axiosGetRequest(
            `/docente/v1/centros-resultado/atividades/${selectActivity?.atividadeId}/campus/${selectCampus}`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newCoverage.push({
                    value: data.centroResultadoId,
                    label: data.nome,
                })
            );
            setGetCoverageValue(response.data);
            setCoverage(newCoverage);
        }
    }

    async function getStudents(
        centroResultadoId: number | undefined
    ): Promise<StudentInfo[]> {
        if (!centroResultadoId) {
            return [
                {
                    value: "",
                    label: "",
                },
            ];
        }
        const newStudentName = new Array<StudentInfo>();
        const newStudentId = new Array<StudentInfo>();

        const response = await axiosGetRequest(
            `/docente/v1/estudantes/${centroResultadoId}`,
            acessToken,
            msalAplication
        );

        response.data.forEach((data: any) =>
            newStudentName.push({
                value: data.nome,
                label: data?.cpf !== "" ? data.cpf : data.passaporte,
                studentId: data.estudanteId,
            })
        );

        response.data.forEach((data: any) =>
            newStudentId.push({
                value: data?.cpf !== "" ? data.cpf : data.passaporte,
                label: data.nome,
                studentId: data.estudanteId,
            })
        );

        setGetStudentsValue(response.data);
        setStudentsId(newStudentName);
        setStudentsName(newStudentId);
        return newStudentName;
    }

    async function getActivities() {
        const newActivity = new Array<SelectOption>();

        const response = await axiosGetRequest(
            `/docente/v1/professores/${selectTeachers?.docenteID}/atividades`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newActivity.push({
                    value: data.atividadeId,
                    label: data.descricaoAtividade,
                })
            );
            setActivities(newActivity);
            setGetActivitiesValue(response.data);
        }
    }

    async function getPeriods() {
        const newPeriods: any[] = [
            {
                value: "",
                text: "Selecione o semestre",
            },
        ];
        const response = await axiosGetRequest(
            `/docente/v1/professores/${selectTeachers?.docenteID}/vigencias-plano-atividade`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newPeriods.push({
                    value: data.planoAtividadeId,
                    text: `${data.semestre}º semestre de ${data.ano}`,
                })
            );
            setPeriodsValidity(response.data);
            setPeriods(newPeriods);
        }
    }

    async function getTimeTypes() {
        const newPeriods: any[] = [
            {
                value: "",
                text: "Tipo de hora",
            },
        ];
        const response = await axiosGetRequest(
            "/docente/v1/planosatividade/tipos-hora",
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response.data.map((data: any) =>
                newPeriods.push({
                    value: data.tipoHoraId,
                    text: data.tipoHoraDescricao,
                })
            );

            setTimeTypeResponse(response.data);
            setTimeType(newPeriods);
        }
    }

    async function getTeachingActivity(index: number) {
        const response = await axiosGetRequest(
            `/docente/v1/planosatividade/${index}`,
            acessToken,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(response)) {
            setFinalDate(response.data.dataVigenciaFim);
            setInitialDate(response.data.dataVigenciaInicio);
            setValidity(response.data.vigenciaPlanoAtividade);

            setCurrentStatusActivityPlan(
                response.data.planoAtividadeStatusIdAtual
            );

            setEditTach(
                response.data.planoAtividadeStatusIdAtual
                    .planoAtividadeStatusId !== 1
            );
            setPreviousStatusActivityPlan(
                response.data.planoAtividadeStatusIdAnterior
            );

            setTeachingActivity(response.data);
        }
    }

    function actionShowModalError(msg: string) {
        setModalErrorText(msg);
        setShowModalError(true);
    }

    async function putStudentValidate(params: any): Promise<boolean> {
        const response = await axiosPutRequest(
            `docente/v1/estudantes/${params.estudanteId}/validacao`,
            params,
            acessToken,
            msalAplication
        );

        if (response.data.code === 500) {
            actionShowModalError(response.data.details);
            return false;
        }

        if (response.data.code === 400) {
            actionShowModalError(response.data.details);
            return false;
        }

        return true;
    }

    function resetStudentsForm() {
        setSelectedStudentsId([]);
        setSelectedStudentsName([]);
        setStudentsForm(getNewStudentsFormValue());
    }

    function resetNewActivityForm() {
        setSelectedActivity([]);
        setSelectActivity(null);
        setSelectCampus(null);
        setSelectedCampus([]);
        setSelectedCoverage([]);
        setSelectCoverage(null);
        setSelectNumberHours("");
        setTextArea("");
        resetStudentsForm();
    }

    async function setWorkLoadHours(selectTeacherId: any) {
        if (!selectTeacherId?.matriculaAdp) {
            return;
        }
        const matriculaAdp = selectTeacherId?.matriculaAdp
            ? `&nome=${selectTeacherId.nome}`
            : "";
        const response = await axiosGetRequest(
            `/docente/v1/professores?_limit=500000&ativos=true&rescisao=false&horasTotais=true${matriculaAdp}`,
            acessToken,
            msalAplication
        );

        const { data } = response;

        if (data && data.length > 0) {
            const professorData = data[0] as TypeProfessorData;
            const {
                horaNaoLetivaEventual = 0,
                horaNaoLetivaSubstituicao = 0,
                naoLetivaBase = 0,
            } = professorData;
            const horasNaoLetivasSomadas =
                horaNaoLetivaEventual +
                naoLetivaBase +
                horaNaoLetivaSubstituicao;
            setWorkloadBase(horasNaoLetivasSomadas);
            setWorkloadOriginalBase(horasNaoLetivasSomadas);
            setWorkloadHistoric(professorData);
        }
    }

    const setStates = async (teacher: any) => {
        setActivityPlan([]);
        setWorkloadHistoricExtraData(initialWorkloadHistoricExtraData);
        await setWorkLoadHours(teacher);
        setSelectTeachers(teacher);
        setIsCreatePlan(false);
        setTable([]);
        setDisabledCriarTach(desabilitarCargaHoraria(teacher));
        resetNewActivityForm();
    };

    async function onChangeSelected() {
        if (selected.length > 0) {
            const selectTeacherId = getTeachers.find(
                (teacher) => teacher.matriculaAdp === selected[0].value
            );

            await setStates(selectTeacherId);
        } else {
            setSelectTeachers(undefined);
            setSelectPeriods("");
        }
    }

    async function onChangeSelectedMyProfile() {
        if (pathLocation[1] === Routes.MeuPlano && !selected.length) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const selectTeacherId = getTeachers.find(
                (teacher) =>
                    teacher.matriculaAdp === user?.docente?.matriculaAdp
            );

            await setStates(user.docente);
        }
    }

    async function refreshActivityPlan(
        activityPlanId: number,
        isDraft: boolean
    ) {
        setTable([]);
        if (pathLocation[1] === Routes.MeuPlano) {
            onChangeSelectedMyProfile();
        } else {
            onChangeSelected();
        }
        if (!isDraft && activityPlanId) {
            getTeachingActivity(activityPlanId);
        }
    }

    async function postActivityPlans(params: any): Promise<boolean> {
        const response = await axiosPostRequest(
            `/docente/v1/planosatividade`,
            params,
            acessToken,
            msalAplication
        );

        if (
            !response ||
            response?.code === "ERR_BAD_REQUEST" ||
            response?.code === "ERR_BAD_RESPONSE" ||
            response?.status === 500 ||
            response?.status === 400
        ) {
            const responseData = response?.response?.data || response?.data;
            const httpStatusCode = Number(responseData?.code) || 500;
            if (!response || httpStatusCode === 500) {
                setModalError(true);
                return false;
            }

            if (httpStatusCode >= 400 && httpStatusCode < 500) {
                if (responseData.details) {
                    actionShowModalError(responseData.details);
                } else {
                    setModalError(true);
                }
                return false;
            }
        }

        const resp = response?.headers?.location?.split("/");
        setUrlResponse(response.data);
        refreshActivityPlan(resp[2], params.rascunho);
        return true;
    }

    function updateTachStatus(planList: any[], currentWorkload: any) {
        const sortedPlans = [...planList].sort(
            (a, b) => b.planoAtividadeDocenteId - a.planoAtividadeDocenteId
        );
        const lastPlan = sortedPlans[0];

        if (
            lastPlan.planoAtividadeDocenteStatus === "Finalizado" &&
            lastPlan.cargaHorariaTotal !== currentWorkload.cargaHorariaTotal &&
            periodsValidity.length !== 0 &&
            (currentWorkload.naoLetivaBase > 0 ||
                currentWorkload.horaNaoLetivaEventual > 0 ||
                currentWorkload.horaNaoLetivaSubstituicao > 0)
        ) {
            lastPlan.planoAtividadeDocenteStatus = "Necessário criar novo TACH";
        }

        return [...sortedPlans];
    }

    async function getTeacherData() {
        try {
            const [workloadResponse, activityPlansResponse] = await Promise.all(
                [
                    axiosGetRequest(
                        `/docente/v1/professores/${selectTeachers?.docenteID}/carga-horaria`,
                        acessToken,
                        msalAplication
                    ),
                    axiosGetRequest(
                        `/docente/v1/planosatividade/professores/${selectTeachers?.docenteID}`,
                        acessToken,
                        msalAplication
                    ),
                ]
            );

            if (GenericUtils.isSuccessStatus(workloadResponse)) {
                setGetWorkloadValue(workloadResponse.data);
                setDisabledCriarTach(
                    desabilitarCargaHoraria(workloadResponse.data)
                );
            }

            if (
                GenericUtils.isSuccessStatus(activityPlansResponse) &&
                activityPlansResponse.data.length
            ) {
                const activityPlans = activityPlansResponse.data;

                const updatedPlans = updateTachStatus(
                    activityPlans,
                    workloadResponse.data
                );

                setActivityPlan(updatedPlans);
                setWorkloadHistoricExtraData(updatedPlans[0]);
            }
        } catch (requestError) {
            console.error("Erro ao buscar dados do docente:", requestError);
        }
    }

    async function onChangeBookingHours(): Promise<{
        table: any[];
        workloadBase: number;
        hoursUsed: number;
    }> {
        const docenteId = selectTeachers?.docenteID;
        const newTable = [...table];
        let hoursUsedValue = 0; // Reservas do periodo selecionado (resultado do responseReserve)
        let workLoadTemp = 0;
        let totalReservaBase = 0;
        let totalReservaEventual = 0;
        let totalReservaSubstituicao = 0;

        const responseCurrentWorkload = await axiosGetRequest(
            `/docente/v1/professores/${docenteId}/carga-horaria`,
            acessToken,
            msalAplication
        );

        const currentWorkload = GenericUtils.isSuccessStatus(
            responseCurrentWorkload
        )
            ? responseCurrentWorkload.data
            : workloadValue;

        if (GenericUtils.isSuccessStatus(responseCurrentWorkload)) {
            setGetWorkloadValue(responseCurrentWorkload.data);
        }

        const responseHorasDisponiveis =
            await ProfessorService.getAvailableHours(
                msalAplication,
                docenteId,
                validaDataVigenciaInicioPlano()
            );
        const responseReserve =
            await AcademicActivityPlanService.getReserveWorkload(
                docenteId,
                validaDataVigenciaInicioPlano(),
                finalDate,
                msalAplication
            );
        const responseCurricularMatrix =
            await AcademicActivityPlanService.getCurricularMatrix(
                docenteId,
                validaDataVigenciaInicioPlano(),
                finalDate,
                msalAplication
            );

        const isValidResponse =
            GenericUtils.isSuccessStatus(responseReserve) &&
            GenericUtils.isSuccessStatus(responseCurricularMatrix) &&
            GenericUtils.isSuccessStatus(responseHorasDisponiveis);

        if (isValidResponse) {
            responseReserve.data
                ?.filter((filterItem: any) => filterItem?.atividade)
                .forEach((item: any) => {
                    newTable.push({
                        id: item?.planoAtividadeDocenteItemId,
                        activity: item?.atividade,
                        campus: item.centroResultado.campus || "",
                        coverage: item.centroResultado,
                        students: item.estudantes || [],
                        detailing: item.detalhamentoAtividade || "",
                        hour: item.cargaHoraria,
                        typeHour: item.tipoHora.tipoHoraDescricao,
                        dataVigenciaInicio: item.dataVigenciaInicio,
                        dataVigenciaFim: item.dataVigenciaFim,
                        workloadValid: true,
                        hoursBookings: {
                            reservaCargaHorariaId: item.reservaCargaHorariaId,
                            contagemCargaHoraria: item.contagemCargaHoraria,
                        },
                        tableIndex: newTable.length,
                    });
                    hoursUsedValue +=
                        item.contagemCargaHoraria.contagemCargaHorariaDescricao.toUpperCase() ===
                        ContagemCargaHorariaEnumLabel.get(
                            ContagemCargaHorariaEnum.NaoLetivaBase
                        )?.toUpperCase()
                            ? item.cargaHoraria
                            : 0;
                });

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            responseReserve.data.forEach((item: any) => {
                if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaBase
                ) {
                    totalReservaBase += item.cargaHoraria;
                } else if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaEventual
                ) {
                    totalReservaEventual += item.cargaHoraria;
                } else if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaSubstituicao
                ) {
                    totalReservaSubstituicao += item.cargaHoraria;
                }
            });

            let totalReservaFlutuanteBase = 0;
            let totalReservaFlutuanteEventual = 0;
            let totalReservaFlutuanteSubstituicao = 0;
            responseCurricularMatrix.data.itens.forEach((item: any) => {
                if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaBase
                ) {
                    totalReservaFlutuanteBase += item.cargaHoraria;
                } else if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaEventual
                ) {
                    totalReservaFlutuanteEventual += item.cargaHoraria;
                } else if (
                    item.contagemCargaHoraria.contagemCargaHorariaId ===
                    ContagemCargaHorariaEnum.NaoLetivaSubstituicao
                ) {
                    totalReservaFlutuanteSubstituicao += item.cargaHoraria;
                }
            });

            totalReservaFlutuanteBase += totalReservaBase;
            totalReservaFlutuanteEventual += totalReservaEventual;
            totalReservaFlutuanteSubstituicao += totalReservaSubstituicao;

            setHoraNaoLetivaFlutuanteReservaBase(totalReservaFlutuanteBase);
            setHoraNaoLetivaFlutuanteReservaEventual(
                totalReservaFlutuanteEventual
            );
            setHoraNaoLetivaFlutuanteReservaSubstituicao(
                totalReservaFlutuanteSubstituicao
            );

            // Horas do docente disponiveis (ja subtraidas as flutuantes do periodo selecionado)
            workLoadTemp = Number(
                responseHorasDisponiveis.data - hoursUsedValue
            );

            // );
            setWorkloadEventual(
                Number(currentWorkload?.horaNaoLetivaEventual) -
                    totalReservaEventual
            );
            setWorkloadSubstituicao(
                Number(currentWorkload?.horaNaoLetivaSubstituicao) -
                    totalReservaSubstituicao
            );
        }
        return {
            table: newTable,
            workloadBase: workLoadTemp,
            hoursUsed:
                hoursUsedValue +
                totalReservaEventual +
                totalReservaSubstituicao,
        };
    }

    // So impacta no calculo caso seja o segundo plano criado (com um finalizado antes)
    async function onChangeActivityFromLastFinalizedPlan(
        tableAux: AcademicActivityPlansItem[],
        workloadBaseParam: number,
        hoursUsedParam: number
    ): Promise<{
        table: any[];
        workloadBase: number;
        hoursUsed: number;
    }> {
        const docenteId = selectTeachers?.docenteID;
        const newTable = [...tableAux];
        let hoursUsedValue = 0;
        let workloadTemp = workloadBaseParam;

        const responseActivityPlan =
            await AcademicActivityPlanService.getActivityPlan(
                docenteId,
                selectPeriods,
                msalAplication
            );

        const isValidResponse =
            GenericUtils.isSuccessStatus(responseActivityPlan) &&
            responseActivityPlan.data.length;

        if (isValidResponse) {
            responseActivityPlan.data.forEach((item: any) => {
                newTable.push({
                    id: null,
                    activity: item.atividade,
                    campus: item.campus,
                    coverage: item.abrangencia,
                    students: item.estudantes || [],
                    detailing: item.atividadeDetalhamento,
                    hour: item.cargaHoraria,
                    typeHour: item.tipoHora.tipoHoraDescricao,
                    dataVigenciaInicio: item.dataVigenciaInicio,
                    dataVigenciaFim: item.dataVigenciaFim,
                    hoursBookings: {},
                    workloadValid: false,
                    tableIndex: newTable.length + item.atividade.atividadeId,
                });
                hoursUsedValue += item.cargaHoraria;
            });

            workloadTemp = workloadBaseParam - hoursUsedValue;

            const statusIdAtual = { planoAtividadeStatusId: 3 };
            const statusIdAnterior = { planoAtividadeStatusId: 6 };

            setPreviousStatusActivityPlan(statusIdAnterior);
            setCurrentStatusActivityPlan(statusIdAtual);
        }

        hoursUsedValue += hoursUsedParam;

        return {
            table: newTable,
            workloadBase: workloadTemp,
            hoursUsed: hoursUsedValue,
        };
    }

    async function getHourBookingsAndActiviyFromLastFinalizedPlan() {
        let tableAux = await onChangeBookingHours();

        tableAux = await onChangeActivityFromLastFinalizedPlan(
            tableAux.table,
            tableAux.workloadBase,
            tableAux.hoursUsed
        );

        setTable(tableAux.table);
        setWorkloadBase(tableAux.workloadBase);
        setHoursUsed(tableAux.hoursUsed);
    }

    async function getValidateDataLock() {
        const response = await ActivityPlanBlocksService.getValidateDataLock(
            msalAplication
        );

        setIsBlockPeriod(response.data);
    }

    function onChangeSelectedActivity() {
        if (selectedActivity.length > 0) {
            const selectActivitiesId = getActivitiesValue.find(
                (activity) => activity.atividadeId === selectedActivity[0].value
            );
            setSelectActivity(selectActivitiesId);
            setIsStudents(selectActivitiesId?.temEstudante === "S");
            setTextArea(
                selectActivitiesId?.atividadeDetalhamentoDescricao || ""
            );
            setActivityTooltip(selectActivitiesId?.descricaoExplicativa);
            setMandatoryDetailing(selectActivitiesId?.detalhamentoObrigatorio);
        } else {
            setSelectNumberHours("");
            setSelectedCampus([]);
            setSelectedCoverage([]);
            setSelectActivity(false);
            resetStudentsForm();
            setIsStudents(false);
            setActivityTooltip("");
        }
    }

    function onChangeSelectActivity() {
        if (selectActivity) {
            getCampus();
        } else {
            setSelectedCampus([]);
            setTextArea("");
            resetStudentsForm();
        }
    }

    function onChangeSelectedCampus() {
        if (selectedCampus.length > 0) {
            const selectCampusId = getCampusValue.find(
                (campusValue) => campusValue === selectedCampus[0].value
            );

            setSelectCampus(selectCampusId);
        } else {
            setSelectCampus(false);
            setSelectedCoverage([]);
        }
    }

    function onChangeSelectedCoverage() {
        resetStudentsForm();
        if (selectedCoverage.length > 0) {
            const selectCoverageId = getCoverageValue.find(
                (coverageValue) =>
                    coverageValue.centroResultadoId ===
                    selectedCoverage[0].value
            );

            setSelectCoverage(selectCoverageId);
            setCoverageTooltip(selectCoverageId?.nome);
            getStudents(selectCoverageId?.centroResultadoId);
        } else {
            setSelectCoverage(false);
        }
    }

    function onChangeTimeTypeResponse() {
        if (timeTypeResponse) {
            setSelectTimeType(
                timeTypeResponse.find(
                    (select) => select.tipoHoraId === TipoHoraEnum.Normal
                )?.tipoHoraId
            );
        }
    }

    function onChangeTeachingActivity() {
        if (teachingActivity) {
            const newTable: any[] = [];
            let totalHours = 0;
            let totalNormalHours = 0;
            let totalEventualHours = 0;
            let totalSubstituicaoHours = 0;

            teachingActivity?.planoAtividadeDocenteItems?.forEach(
                (item: any) => {
                    const itemTipoHora =
                        item?.tipoHora?.tipoHoraDescricao?.toLowerCase() || "";

                    newTable.push({
                        id: item?.planoAtividadeDocenteItemId || null,
                        activity: item.atividade,
                        campus: item.campus,
                        coverage: item.abrangencia,
                        students: item.estudantes || [],
                        detailing: item.atividadeDetalhamento,
                        hour: item.cargaHoraria,
                        typeHour: item.tipoHora.tipoHoraDescricao,
                        dataVigenciaInicio: item.dataVigenciaInicio,
                        dataVigenciaFim: item.dataVigenciaFim,
                        hoursBookings: {
                            reservaCargaHorariaId:
                                item?.reservaCargaHoraria
                                    ?.reservaCargaHorariaId,
                            contagemCargaHoraria:
                                item?.reservaCargaHoraria?.contagemCargaHoraria,
                        },
                        workloadValid:
                            !!item?.reservaCargaHoraria?.reservaCargaHorariaId,
                        tableIndex:
                            newTable.length + item.atividade.atividadeId,
                    });
                    totalHours += item.cargaHoraria;

                    if (
                        itemTipoHora ===
                        TipoHoraEnumLabel.get(
                            TipoHoraEnum.Normal
                        )?.toLowerCase()
                    ) {
                        totalNormalHours += Number(item.cargaHoraria || 0);
                    }

                    if (
                        itemTipoHora ===
                        TipoHoraEnumLabel.get(
                            TipoHoraEnum.Eventual
                        )?.toLowerCase()
                    ) {
                        totalEventualHours += Number(item.cargaHoraria || 0);
                    }

                    if (
                        itemTipoHora ===
                        TipoHoraEnumLabel.get(
                            TipoHoraEnum.Substituicao
                        )?.toLowerCase()
                    ) {
                        totalSubstituicaoHours += Number(
                            item.cargaHoraria || 0
                        );
                    }
                }
            );

            const currentBase = Number(workloadValue?.naoLetivaBase || 0);
            const currentEventual = Number(
                workloadValue?.horaNaoLetivaEventual || 0
            );
            const currentSubstituicao = Number(
                workloadValue?.horaNaoLetivaSubstituicao || 0
            );

            const newWorkloadBase = currentBase - totalNormalHours;
            const newWorkloadEventual = currentEventual - totalEventualHours;
            const newWorkloadSubstituicao =
                currentSubstituicao - totalSubstituicaoHours;

            setWorkloadBase(newWorkloadBase);
            setWorkloadEventual(newWorkloadEventual);
            setWorkloadSubstituicao(newWorkloadSubstituicao);
            setWorkloadOriginalBase(newWorkloadBase);
            setWorkloadOriginalEventual(newWorkloadEventual);
            setWorkloadOriginalSubstituicao(newWorkloadSubstituicao);

            setHoursUsed(totalHours);
            setTable(newTable);
            setIsCreatePlan(true);
        }
    }

    function onChangeSelectTeachers() {
        if (selectTeachers) {
            getPeriods();
            getTeacherData();
            getActivities();
            getTimeTypes();
        }
    }

    function getActiveTeachersByLocation(currentPathLocation: string) {
        if (currentPathLocation === Routes.MeuPlano) {
            setSelected([]);
            setActivityPlan([]);
            getActiveTeachers(true, user?.docente?.nome);
        }

        if (currentPathLocation === Routes.EditarPlano) {
            setSelectTeachers(undefined);
            setSelected([]);
            setActivityPlan([]);
            getActiveTeachers(false);
        }

        if (currentPathLocation === Routes.ConsultarPlano) {
            setSelected([]);
            setActivityPlan([]);
            setSelectTeachers(undefined);
            setSelectPeriods("");
            getActiveTeachers(false, "", user?.docente.matriculaAdp);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        setNumberHours(getNumbersOption());

        const unloadCallback = (event: any) => {
            event.preventDefault();
            // eslint-disable-next-line no-param-reassign
            event.returnValue = "";
            return "";
        };

        window.addEventListener("beforeunload", unloadCallback);

        return () => {
            // window.addEventListener("popstate", unloadCallback);
            window.removeEventListener("beforeunload", unloadCallback);
        };
    }, []);

    useEffect(() => {
        onChangeSelected();
        getValidateDataLock();
    }, [selected]);

    useEffect(() => {
        onChangeSelectedActivity();
    }, [selectedActivity]);

    useEffect(() => {
        onChangeSelectedCampus();
    }, [selectedCampus]);

    useEffect(() => {
        onChangeSelectedCoverage();
    }, [selectedCoverage]);

    useEffect(() => {
        getActiveTeachersByLocation(pathLocation[1]);
    }, [pathLocation[1]]);

    useEffect(() => {
        onChangeTimeTypeResponse();
    }, [timeTypeResponse]);

    useEffect(() => {
        onChangeTeachingActivity();
    }, [teachingActivity]);

    useEffect(() => {
        onChangeSelectActivity();
    }, [selectActivity]);

    useEffect(() => {
        onChangeSelectTeachers();
    }, [selectTeachers]);

    useEffect(() => {
        if (selectCampus) {
            getCoverage();
        }
    }, [selectCampus]);

    useEffect(() => {
        onChangeSelectedMyProfile();
    }, [getRole(), getRoleConsult(), getTeachers]);

    const actionCloseAllModals = () => {
        setShowDialogTachHistoric(false);
        setShowDialogCreateActivityPlan(false);
        setShowDialogWorkload(false);
        setOpenViewActivity(false);
        setShowDialogNoHours(false);
        setShowDialogEditActivity(false);
        setShowDialogActivityRemoved(false);
        setShowDialogDraft(false);
        setShowDialogActivityPlanSendToAprove(false);
        setModalError(false);
        setModalConfirm(false);
        setShowModalError(false);
        setModalErrorText("");
        setModalErrorStudentAssociado(false);
        setCurrentActivity(getNewActivityPlanItens);
        setShowDialogJustifyEndTach(false);
        setModalAcademicActivityPlanEndPlanHistoricProps(
            endPlanHistoryModalProps
        );
    };

    const actionCloseDialogNoHours = () => {
        setShowDialogNoHours(false);
    };

    const actionDialogDraftOK = () => {
        setShowDialogCreateActivityPlan(false);
        setShowDialogWorkload(false);
        setOpenViewActivity(false);
        setShowDialogNoHours(false);
        setShowDialogEditActivity(false);
        setShowDialogActivityRemoved(false);
        setShowDialogDraft(false);
        setShowDialogActivityPlanSendToAprove(false);
        setModalError(false);
        setModalConfirm(false);
    };

    const actionActivityPlanSendToAproveOK = () => {
        setShowDialogActivityPlanSendToAprove(false);
        setIsCreatePlan(false);
    };

    function getWorkloadValueByType(value: AcademicActivityPlansItem) {
        let workloadAux = 0;
        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Normal)?.toLowerCase()
        )
            workloadAux = workloadBase;

        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Eventual)?.toLowerCase()
        )
            workloadAux = workloadEventual;

        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Substituicao)?.toLowerCase()
        )
            workloadAux = workloadSubstituicao;
        return workloadAux;
    }

    function setWorkloadValueByType(
        value: AcademicActivityPlansItem,
        workloadParam: number
    ) {
        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Normal)?.toLowerCase()
        )
            setWorkloadBase(workloadParam);

        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Eventual)?.toLowerCase()
        )
            setWorkloadEventual(workloadParam);

        if (
            value.typeHour.label.toLowerCase() ===
            TipoHoraEnumLabel.get(TipoHoraEnum.Substituicao)?.toLowerCase()
        )
            setWorkloadSubstituicao(workloadParam);
    }

    const actionSaveActivity = (value: AcademicActivityPlansItem) => {
        const newArray = [...table];

        if (!indexTable && indexTable !== 0) {
            return;
        }
        const workloadAux = getWorkloadValueByType(value);

        const tempWorkload =
            workloadAux - (value.hour.value - newArray[indexTable].hour);

        if (tempWorkload < 0) {
            setShowDialogNoHours(true);
            return;
        }

        setHoursUsed(
            hoursUsed + (value.hour.value - newArray[indexTable].hour)
        );

        setWorkloadValueByType(value, tempWorkload);

        newArray[indexTable] = {
            activity: value.activity,
            coverage: value.coverage,
            detailing: value.detailing,
            hour: value.hour.value,
            students: value.students,
            typeHour: value.typeHour.label,
            dataVigenciaInicio: value.dataVigenciaInicio,
            dataVigenciaFim: value.dataVigenciaFim,
            campus: value.campus.value,
            id: value.id,
            workloadValid: value.workloadValid,
            hoursBookings: value.hoursBookings,
            tableIndex: newArray.length,
        };

        setTable(newArray);
        setCurrentActivity({
            activity: {},
            campus: {},
            coverage: {},
            detailing: {},
            hour: {},
            hoursBookings: {},
            id: undefined,
            students: [],
            typeHour: "",
            dataVigenciaInicio: undefined,
            dataVigenciaFim: undefined,
            workloadValid: {},
            tableIndex: 0,
        });
        setShowDialogEditActivity(false);
        setModalSucess(true);
        setMandatoryDetailing("");
    };

    const actionDialogCreateActivityPlanOK = () => {
        setShowDialogCreateActivityPlan(false);
        setIsCreatePlan(true);
        setTable([]);
        setHoursUsed(0);
        getHourBookingsAndActiviyFromLastFinalizedPlan();
        setTeachingActivity(null);
        setCurrentStatusActivityPlan(null);
        setPreviousStatusActivityPlan(null);
    };

    const removeActivity = () => {
        const newTable = table.filter((_, idx) => indexModal !== idx);
        const newHours = table.filter((_, idx) => indexModal === idx);

        // console.log(table);
        // console.log(newHours[0].hoursBookings?.contagemCargaHoraria);

        const contagemCargaHorariaEhNaoLetivaBase =
            newHours[0].hoursBookings &&
            newHours[0].hoursBookings?.reservaCargaHorariaId
                ? newHours[0].hoursBookings?.contagemCargaHoraria.contagemCargaHorariaDescricao.toUpperCase() ===
                  ContagemCargaHorariaEnumLabel.get(
                      ContagemCargaHorariaEnum.NaoLetivaBase
                  )?.toUpperCase()
                : true;

        if (
            newHours[0].typeHour.toLowerCase() ===
                TipoHoraEnumLabel.get(TipoHoraEnum.Normal)?.toLowerCase() &&
            contagemCargaHorariaEhNaoLetivaBase
        ) {
            setWorkloadBase(workloadBase + Number(newHours[0].hour));
        }

        setHoursUsed(hoursUsed - Number(newHours[0].hour));
        setTable(newTable);
        setModalConfirm(false);
        setShowDialogActivityRemoved(true);
        setIndexModal(null);
    };

    const actionCreateActivityPlan = () => {
        setEditTach(false);
        setShowTableTachHistoric(false);
        setShowDialogCreateActivityPlan(true);
    };

    const actionShowWorkload = () => {
        setShowDialogWorkload(true);
    };

    const theme = {};

    const handlePeriodsSelectChange = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        const periodValue = periods?.filter(
            (period) => period.value.toString() === event.target.value
        );

        const periodValidityValue = periodsValidity?.filter(
            (period) =>
                period.planoAtividadeId.toString() === event.target.value
        );
        setSelectPeriods(event.target.value as string);
        setSelectedPeriod(event.target.value as string);
        setGetPeriodsValidityValue(periodValidityValue);
        setGetPeriodsValue(periodValue);
        setFinalDate(periodValidityValue[0]?.planoAtividadeDtFim);
        setInitialDate(periodValidityValue[0]?.planoAtividadeDtInicio);
    };

    const handleNumbersSelectChange = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        setSelectNumberHours(event.target.value as string);
    };

    const handleTimeSelectChange = (event: ChangeEvent<{ value: unknown }>) => {
        setSelectTimeType(event.target.value as string);
    };

    const handleTextAreaChange = (event: ChangeEvent<{ value: unknown }>) => {
        setTextArea(event.target.value as string);
    };

    async function validItem(newTable: any[], obj: any) {
        for (let i = 0; i < newTable.length; i++) {
            if (
                newTable[i].activity === obj.activity &&
                newTable[i].campus === obj.campus &&
                newTable[i].coverage === obj.coverage &&
                newTable[i].students.find(
                    (value: any) => value.matricula === obj.students.matricula
                )
            ) {
                return true;
            }
        }

        return false;
    }

    const actionCreateActivity = async () => {
        const newTable = [...table];

        if (Number(selectNumberHours) > workloadBase) {
            setShowDialogNoHours(true);
            return;
        }

        if (workloadBase <= 0) {
            setShowDialogNoHours(true);
            setIsStudents(false);
            resetNewActivityForm();
            return;
        }

        const studentsBlank = studentsForm.filter((objId) =>
            selectedStudentsId.some((arr) =>
                arr.some((id: any) => id.studentId === objId.estudanteId)
            )
        );

        const obj = {
            activity: selectActivity,
            coverage: selectCoverage,
            detailing: textArea,
            hour: selectNumberHours,
            students: studentsBlank,
            typeHour: timeTypeResponse.find(
                (select) => select.tipoHoraId === TipoHoraEnum.Normal
            )?.tipoHoraDescricao,
            dataVigenciaInicio: validaDataVigenciaInicioPlano(),
            dataVigenciaFim:
                finalDate || getPeriodsValidityValue[0]?.planoAtividadeDtFim,
            campus: selectCampus,
            tableIndex: newTable.length,
        };
        newTable.push(obj);

        setHoursUsed(hoursUsed + Number(selectNumberHours));
        setWorkloadBase(workloadBase - Number(selectNumberHours));

        setTable(newTable);

        resetNewActivityForm();

        setOpenViewActivity(true);
    };

    const handleOpenModalDetailsAcademicActivity = (
        teachingActivityPlanId: number
    ) => {
        setModalDetailsAcademicActivityProps({
            open: true,
            teachingActivityPlanId,
        });
    };

    const handleOpenModalActivityPlanHistoric = (
        teachingActivityPlanId: number,
        vigencia: string,
        dataVigenciaInicio: string,
        dataVigenciaFim: string
    ) => {
        setShowDialogTachHistoric(true);
        setModalAcademicActivityPlanHistoricProps({
            open: true,
            teachingActivityPlanId,
        });
        setWorkloadHistoricExtraData({
            planoAtividadeDocenteId: teachingActivityPlanId,
            vigencia,
            dataVigenciaInicio,
            dataVigenciaFim,
        });
    };

    const isDisableEdit = (plan: any) => {
        return (
            (pathLocation[1] === Routes.MeuPlano && isBlockPeriod) ||
            (pathLocation[1] === Routes.MeuPlano &&
                plan.planoAtividadeDocenteStatusId ===
                    PlanoAtividadeStatusEnum.AguardandoAprovacao) ||
            (pathLocation[1] === Routes.MeuPlano &&
                StringUtils.isBeforeCurrentDateTime(
                    plan?.dataVigenciaFim,
                    MASK_DATE
                )) ||
            (pathLocation[1] === Routes.EditarPlano &&
                plan.planoAtividadeDocenteStatusId ===
                    PlanoAtividadeStatusEnum.AguardandoAprovacao) ||
            plan.planoAtividadeDocenteStatusId ===
                PlanoAtividadeStatusEnum.Finalizado
        );
    };

    const modalDetailsAcademicActivityPlan =
        modalDetailsAcademicActivityProps.open && (
            <ModalDetailsAcademicActivity
                open={modalDetailsAcademicActivityProps.open}
                teachingActivityPlanId={
                    modalDetailsAcademicActivityProps.teachingActivityPlanId
                }
                onClose={() =>
                    setModalDetailsAcademicActivityProps(Object.create({}))
                }
            />
        );

    const DialogCreateActivityPlan = (
        <Dialog
            openModal={showDialogCreateActivityPlan}
            onHide={actionCloseAllModals}
        >
            <StyledModalTitle>
                Selecione o semestre do TACH a ser criado
            </StyledModalTitle>
            <InputSelect
                value={selectPeriods}
                handleSelectChange={handlePeriodsSelectChange}
                optionsSelect={periods}
            />
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionDialogCreateActivityPlanOK}
                disabled={!selectPeriods}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogError = (
        <Dialog
            openModal={modalError}
            onHide={actionCloseAllModals}
            modalIcon={<InformationModal />}
        >
            <StyledModalText>
                Ocorreu um erro interno inesperado no sistema. Tente novamente e
                se o problema persistir, entre em contato com o administrador do
                sistema.
            </StyledModalText>

            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionCloseAllModals}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogErrorMessage = (
        <Dialog
            openModal={showModalError}
            onHide={actionCloseAllModals}
            modalIcon={<InformationModal />}
        >
            <StyledModalText>{modalErrorText}</StyledModalText>

            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionCloseAllModals}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogConfirmRemoveActitivy = (
        <Dialog openModal={modalConfirm} onHide={actionCloseAllModals}>
            <StyledModalTitle>
                Deseja remover a atividade selecionada{" "}
                {table.find((_, idx) => indexModal === idx)?.workloadValid
                    ? " (Reserva Carga Horária) "
                    : ""}
                ?
            </StyledModalTitle>
            {table.find((_, idx) => indexModal === idx)?.workloadValid ? (
                <StyledModalText>
                    Ao confirmar a remoção, a ação não poderá ser desfeita.
                </StyledModalText>
            ) : null}

            <StyledImportButton
                style={{ width: 126, marginTop: 24 }}
                onClick={removeActivity}
            >
                Remover
            </StyledImportButton>
        </Dialog>
    );

    const DialogNoHours = (
        <Dialog
            openModal={showDialogNoHours}
            onHide={actionCloseDialogNoHours}
            modalIcon={<InformationModal />}
        >
            <StyledModalTitle>Não há horas disponíveis</StyledModalTitle>
            <StyledModalText>
                Para incluir uma nova atividade, remova ou edite as horas
                utilizadas nas atividades incluídas
            </StyledModalText>
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionCloseDialogNoHours}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogActivityIncluded = (
        <Dialog
            openModal={showDialogActivityIncluded}
            onHide={actionCloseAllModals}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>Atividade incluída</StyledModalTitle>
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionCloseAllModals}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogActivityPlanSendToAprove = (
        <Dialog
            openModal={showDialogActivityPlanSendToAprove}
            onHide={actionCloseAllModals}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>Enviado para aprovação</StyledModalTitle>
            <StyledModalText>
                TACH enviado. Aguarde a aprovação do coordenador
            </StyledModalText>
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionActivityPlanSendToAproveOK}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogDraft = (
        <Dialog
            openModal={showDialogDraft}
            onHide={actionDialogDraftOK}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>Rascunho salvo</StyledModalTitle>
            <StyledModalText>
                Você ainda deverá enviar seu TACH para aprovação
            </StyledModalText>
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionDialogDraftOK}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogActivityRemoved = (
        <Dialog
            openModal={showDialogActivityRemoved}
            onHide={actionCloseAllModals}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>Atividade removida</StyledModalTitle>
            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={actionCloseAllModals}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const actionEditActivityPlan = (
        selectPeriodsParam: string,
        planoAtividadeDocenteId: number,
        vigencia: any
    ) => {
        setShowTableTachHistoric(true);
        getTeachingActivity(planoAtividadeDocenteId);

        setGetPeriodsValue([
            {
                text: vigencia,
                value: planoAtividadeDocenteId,
            },
        ]);
        setSelectPeriods(planoAtividadeDocenteId.toString());
        setSelectedPeriod(selectPeriodsParam);
        setWorkloadHistoricExtraData({
            ...workloadHistoricExtraData,
            planoAtividadeDocenteId,
        });
    };

    const DialogActivityEdit = (
        <EditAcademicActivity
            teachingActivity={teachingActivity}
            period={selectedPeriod}
            teacher={selectTeachers}
            open={showDialogEditActivity}
            onHide={actionCloseAllModals}
            onOkClose={actionSaveActivity}
            activitiesList={getActivitiesValue}
            activityValue={currentActivity}
            activitityPlansItems={table}
            workloadOriginal={workloadOriginalBase}
            workloadOriginalEventual={workloadOriginalEventual}
            workloadOriginalSubstituicao={workloadOriginalSubstituicao}
            instanceMsal={msalAplication}
            isConsultProfile={pathLocation[1] === Routes.ConsultarPlano}
            isDACProfile={pathLocation[1] === Routes.EditarPlano}
        />
    );

    const DialogWorkload = (
        <Dialog
            className="workload"
            size="lg"
            openModal={showDialogWorkload}
            onHide={actionCloseAllModals}
        >
            <StyledModalTitle>Carga horária</StyledModalTitle>
            <StyledModalText>{`Última atualização: ${StringUtils.formatDateValueString(
                new Date(),
                "dd/MM/yyyy 'às' HH'h'mm'min'"
            )}`}</StyledModalText>
            <StyledModalHeader
                style={{
                    fontWeight: "600",
                    paddingTop: "12px",
                }}
            >
                <p>Composição de carga horária</p>
            </StyledModalHeader>
            <StyledFlexDivSpaceBetween>
                <StyledTimeDiv style={{ width: "75%" }}>
                    <p>Letivas Regulares</p>
                    <p>Letivas Eventuais</p>
                    <p>Letivas de Substituição</p>
                </StyledTimeDiv>
                <StyledTimeDiv
                    style={{
                        textAlign: "end",
                        paddingRight: "12px",
                    }}
                >
                    <p>{workloadValue?.letivaBase} h/a</p>
                    <p>{workloadValue?.horaLetivaEventual} h/a</p>
                    <p>{workloadValue?.horaLetivaSubstituicao} h/a</p>
                </StyledTimeDiv>
            </StyledFlexDivSpaceBetween>
            <StyledFlexDivSpaceBetween>
                <StyledTimeDiv style={{ width: "75%" }}>
                    <p>Não Letivas/ Permanência Regulares</p>
                    <p>Não Letivas/ Permanência Eventuais</p>
                    <p>Não Letivas/ Permanência Substituição</p>
                </StyledTimeDiv>
                <StyledTimeDiv
                    style={{
                        textAlign: "end",
                        paddingRight: "12px",
                    }}
                >
                    <p>{workloadValue?.naoLetivaBase} h/a</p>
                    <p>{workloadValue?.horaNaoLetivaEventual} h/a</p>
                    <p>{workloadValue?.horaNaoLetivaSubstituicao} h/a</p>
                </StyledTimeDiv>
            </StyledFlexDivSpaceBetween>
            <StyledFlexDivSpaceBetween style={{ border: "solid 1px #f0f2f2" }}>
                <div style={{ width: "100%", textAlign: "start" }}>
                    <StyledTextPlan padding={8} margin-top={12}>
                        Carga horária total
                    </StyledTextPlan>
                </div>
                <div
                    style={{
                        width: "100%",
                        textAlign: "end",
                    }}
                >
                    <StyledCardTitle
                        style={{
                            fontSize: "15px",
                            fontWeight: "700",
                            lineHeight: "150%",
                            padding: "12px 8px 0 12px",
                        }}
                    >
                        {workloadValue?.cargaHorariaTotal} h/a
                    </StyledCardTitle>
                </div>
            </StyledFlexDivSpaceBetween>
            <div>
                <StyledImportButton
                    style={{ width: 84, marginTop: 24 }}
                    onClick={actionCloseAllModals}
                >
                    OK
                </StyledImportButton>
            </div>
        </Dialog>
    );

    const isValidCreatePlan = isCreatePlan && selectPeriods !== "";
    const isValidMandatory = mandatoryDetailing === "S" && textArea === "";
    const isValid = () => {
        return !selectCoverage || isValidMandatory || selectNumberHours === "";
    };

    const styleStatus = (status: string) => {
        if (
            [
                PlanoAtividadeStatusEnumLabel.get(
                    PlanoAtividadeStatusEnum.Aprovado
                ),
                PlanoAtividadeStatusEnumLabel.get(
                    PlanoAtividadeStatusEnum.Finalizado
                ),
            ].includes(status)
        ) {
            return "#327E38";
        }

        if (
            status ===
            PlanoAtividadeStatusEnumLabel.get(
                PlanoAtividadeStatusEnum.Reprovado
            )
        ) {
            return "#E21D45";
        }

        return "#A16000";
    };

    const getStatusLabel = (status: string) => {
        if (status === "Reprovado" || status === "Inconsistente") {
            return "Necessário Ajuste";
        }
        return status;
    };

    const parseHourValue = (value: any): number => {
        if (typeof value === "number") {
            return Number.isFinite(value) ? value : 0;
        }

        if (typeof value === "string") {
            const normalized = value.replace(".", "").replace(",", ".");
            const parsed = Number(normalized);
            return Number.isFinite(parsed) ? parsed : 0;
        }

        return 0;
    };

    const normalizeTypeHour = (typeHour: any): string => {
        const rawValue =
            typeof typeHour === "string"
                ? typeHour
                : typeHour?.label || typeHour?.tipoHoraDescricao || "";

        return rawValue
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();
    };

    const hasWorkloadOverflow = () => {
        const currentBase = parseHourValue(workloadValue?.naoLetivaBase);
        const currentEventual = parseHourValue(
            workloadValue?.horaNaoLetivaEventual
        );
        const currentSubstituicao = parseHourValue(
            workloadValue?.horaNaoLetivaSubstituicao
        );

        let allocatedBase = 0;
        let allocatedEventual = 0;
        let allocatedSubstituicao = 0;

        table.forEach((item: any) => {
            const hour = parseHourValue(item?.hour);
            const typeHour = normalizeTypeHour(item?.typeHour);

            if (typeHour === normalizeTypeHour("Normal")) {
                allocatedBase += hour;
            } else if (typeHour === normalizeTypeHour("Eventual")) {
                allocatedEventual += hour;
            } else if (typeHour === normalizeTypeHour("Substituição")) {
                allocatedSubstituicao += hour;
            } else {
                // Unknown type is treated as regular to avoid approving inconsistent plans.
                allocatedBase += hour;
            }
        });

        return (
            allocatedBase > currentBase ||
            allocatedEventual > currentEventual ||
            allocatedSubstituicao > currentSubstituicao
        );
    };

    const isApprovalDisabled =
        workloadBase !== 0 || !table.length || hasWorkloadOverflow();

    const workloadOverflowBadgeColor =
        process.env.REACT_APP_WORKLOAD_OVERFLOW_BADGE_COLOR || "#9654FF";

    const getWorkloadBadgeColor = () => {
        if (workloadBase < 0) {
            return workloadOverflowBadgeColor;
        }

        if (workloadBase === 0) {
            return "#787878";
        }

        return "#9654FF";
    };

    const modalAcademicActivityPlanHistoric = (
        <Dialog
            openModal={modalAcademicActivityPlanHistoricProps.open}
            onHide={actionCloseAllModals}
            size="xl"
            style={{ padding: "25px 0" }}
        >
            <StyledTitleHistoric>Histórico de Aprovações</StyledTitleHistoric>
            <StyledHistoricInfoIcons>
                <StyledIconInfo>
                    <UserIcon />
                    <span>{`Professor ${workloadHistoric.nome}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>{`Matrícula: ${workloadHistoric.matriculaAdp}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <PlusIconNoBorder />
                    <span>{`TACH ${workloadHistoricExtraData.vigencia}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>
                        {`Vigência: ${StringUtils.formatDateString(
                            workloadHistoricExtraData.dataVigenciaInicio
                        )} até ${StringUtils.formatDateString(
                            workloadHistoricExtraData.dataVigenciaFim
                        )}`}
                    </span>
                </StyledIconInfo>
            </StyledHistoricInfoIcons>
            <StyledCard>
                <AcademicActivityPlanHistoric
                    teachingActivityPlanId={
                        modalAcademicActivityPlanHistoricProps.teachingActivityPlanId
                    }
                />
            </StyledCard>
            <StyledCenterDiv margin={20}>
                <BtnPrimary onClick={actionCloseAllModals}>Fechar</BtnPrimary>
            </StyledCenterDiv>
        </Dialog>
    );

    const modalAcademicActivityPlanEndHistoric = (
        <Dialog
            openModal={modalAcademicActivityPlanEndPlanHistoricProps.open}
            onHide={actionCloseAllModals}
            size="xl"
            style={{ padding: "25px 0" }}
        >
            <StyledTitleHistoric>Histórico de Finalização</StyledTitleHistoric>
            <StyledHistoricInfoIcons>
                <StyledIconInfo>
                    <UserIcon />
                    <span>{`Professor ${workloadHistoric.nome}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>{`Matrícula: ${workloadHistoric.matriculaAdp}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <PlusIconNoBorder />
                    <span>{`TACH ${endPlanHistoricExtraData.vigencia}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>
                        {`Vigência: ${StringUtils.formatDateString(
                            endPlanHistoricExtraData.dataVigenciaInicio
                        )} até ${StringUtils.formatDateString(
                            endPlanHistoricExtraData.dataVigenciaFim
                        )}`}
                    </span>
                </StyledIconInfo>
            </StyledHistoricInfoIcons>
            <StyledCard>
                <AcademicActivityPlanEndHistoric
                    teachingActivityPlanId={
                        modalAcademicActivityPlanEndPlanHistoricProps.teachingActivityPlanId
                    }
                />
            </StyledCard>
            <StyledCenterDiv margin={20}>
                <BtnPrimary onClick={actionCloseAllModals}>Fechar</BtnPrimary>
            </StyledCenterDiv>
        </Dialog>
    );

    const handleEndTachClick = (planId: number) => {
        setSelectedPlan(planId);
        setShowDialogJustifyEndTach(true);
    };

    const handleCloseModalRequestJustification = async (
        justification: string
    ) => {
        const docenteId = selectTeachers?.docenteID;
        const result = await AcademicActivityPlanService.endTach(
            docenteId,
            selectedPlan,
            justification,
            msalAplication
        );

        if (GenericUtils.isSuccessStatus(result)) {
            setShowDialogJustifyEndTach(false);
            setModalSucess(true);
            setSelectPeriods("");
            onChangeSelectTeachers();
            return;
        }

        setError({
            hasError: true,
            message: result?.data?.details,
            title: result?.data?.message,
        });
        setShowDialogJustifyEndTach(false);
    };

    const justifyEndTachModal = (
        <ModalRequestJustificationEndTach
            open={showDialogJustifyEndTach}
            onClose={actionCloseAllModals}
            onSubmit={handleCloseModalRequestJustification}
        />
    );

    const handleShowEndTachHistoric = (
        teachingActivityPlanId: number,
        vigencia: string,
        dataVigenciaInicio: string,
        dataVigenciaFim: string
    ) => {
        setModalAcademicActivityPlanEndPlanHistoricProps({
            open: true,
            teachingActivityPlanId,
        });
        setEndPlanHistoricExtraData({
            planoAtividadeDocenteId: teachingActivityPlanId,
            vigencia,
            dataVigenciaInicio,
            dataVigenciaFim,
        });
    };

    useEffect(() => {
        if (activityPlan.length && workloadValue) {
            const updatedPlans = updateTachStatus(activityPlan, workloadValue);

            if (JSON.stringify(updatedPlans) !== JSON.stringify(activityPlan)) {
                setActivityPlan(updatedPlans);
            }
        }
    }, [activityPlan, workloadValue]);
    const activityPlanCard = activityPlan.map((plan) => (
        <StyledInformationPlan key={plan?.planoAtividadeDocenteId}>
            <StyledFlexDivAlignCenter>
                <StyledFlexDiv>
                    <InformationIcon
                        style={{
                            fill: styleStatus(
                                plan?.planoAtividadeDocenteStatus
                            ),
                        }}
                    />
                    <StyledTextPlan
                        color={styleStatus(plan?.planoAtividadeDocenteStatus)}
                        padding={10}
                    >
                        {getStatusLabel(plan?.planoAtividadeDocenteStatus)}
                    </StyledTextPlan>
                </StyledFlexDiv>
                <StyledValidity>
                    {`Vigência: ${StringUtils.formatDateString(
                        plan?.dataVigenciaInicio
                    )} até ${StringUtils.formatDateString(
                        plan?.dataVigenciaFim
                    )}`}
                </StyledValidity>
            </StyledFlexDivAlignCenter>
            <div style={{ padding: "16px 0px 28px 0px" }}>
                <StyledText>{plan?.vigencia}</StyledText>
            </div>
            <StyledFlexDivAlignCenter
                style={{ justifyContent: "space-between" }}
            >
                {plan.planoAtividadeDocenteStatus !== "Finalizado" && (
                    <StyledFlexDivAlignCenter>
                        <InformationIcon style={{ fill: "#404040" }} />
                        <StyledTextPlan padding={10}>
                            {plan?.horasDisponiveis} h/a disponíveis
                        </StyledTextPlan>
                    </StyledFlexDivAlignCenter>
                )}

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    {pathLocation[1] === Routes.EditarPlano &&
                        ![
                            PlanoAtividadeStatusEnumLabel.get(
                                PlanoAtividadeStatusEnum.Finalizado
                            ),
                        ].includes(plan.planoAtividadeDocenteStatus) &&
                        user.isDac && (
                            <StyledDefaultButtonLink
                                variant="link"
                                onClick={() =>
                                    handleEndTachClick(
                                        plan.planoAtividadeDocenteId
                                    )
                                }
                            >
                                <CheckIcon style={{ fill: "#8A0538" }} />
                                Finalizar
                            </StyledDefaultButtonLink>
                        )}
                    {pathLocation[1] === Routes.EditarPlano &&
                        plan.planoAtividadeDocenteStatus ===
                            PlanoAtividadeStatusEnumLabel.get(
                                PlanoAtividadeStatusEnum.Finalizado
                            ) && (
                            <StyledDefaultButtonLink
                                variant="link"
                                onClick={() =>
                                    handleShowEndTachHistoric(
                                        plan.planoAtividadeDocenteId,
                                        plan.vigencia,
                                        plan.dataVigenciaInicio,
                                        plan.dataVigenciaFim
                                    )
                                }
                            >
                                <CheckIcon style={{ fill: "#8A0538" }} />
                                Histórico Finalização
                            </StyledDefaultButtonLink>
                        )}

                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() =>
                            handleOpenModalActivityPlanHistoric(
                                plan.planoAtividadeDocenteId,
                                plan.vigencia,
                                plan.dataVigenciaInicio,
                                plan.dataVigenciaFim
                            )
                        }
                    >
                        <InformationIcon style={{ fill: "#8A0538" }} />
                        Histórico aprovações
                    </StyledDefaultButtonLink>
                    <StyledDefaultButtonLink
                        variant="link"
                        onClick={() =>
                            handleOpenModalDetailsAcademicActivity(
                                plan.planoAtividadeDocenteId
                            )
                        }
                    >
                        <ArrowRightIcon style={{ fill: "#8A0538" }} />
                        Ver TACH
                    </StyledDefaultButtonLink>
                    {pathLocation[1] !== Routes.ConsultarPlano && (
                        <StyledDefaultButtonLink
                            variant="link"
                            disabled={
                                isDisableEdit(plan) ||
                                GenericUtils.validaAfastamentoDocente(
                                    selectTeachers
                                )
                            }
                            onClick={() =>
                                actionEditActivityPlan(
                                    plan.vigenciaId,
                                    plan.planoAtividadeDocenteId,
                                    plan.vigencia
                                )
                            }
                        >
                            <EditIcon style={{ fill: "#8A0538" }} />
                            Editar
                        </StyledDefaultButtonLink>
                    )}
                </div>
            </StyledFlexDivAlignCenter>
        </StyledInformationPlan>
    ));

    const actionShowTableActivity = () => {
        setShowTableActivities(!showTableActivities);
    };

    const actionShowTableHistoric = () => {
        setShowTableHistoric(!showTableHistoric);
    };

    const actionFormStudentsAdd = () => {
        const form = [...studentsForm];
        form.push({
            estudanteId: 0,
            centroResultadoId: 0,
            nome: "",
            cpf: "",
            passaporte: "",
            matricula: "",
        });

        setStudentsForm(form);
    };

    const actionFormDeleteLastStudent = () => {
        setStudentsForm(getNewStudentsFormValue());
        setSelectedStudentsId([]);
        setSelectedStudentsName([]);
        setStudentsFormFullFilled(true);
    };

    const actionFormStudentsDelete = (index: number) => {
        if (index === 0) {
            actionFormDeleteLastStudent();
            return;
        }
        const form = [...studentsForm];
        const formStudentsId = [...selectedStudentsId];
        const formStudentsName = [...selectedStudentsName];
        form.splice(index, 1);
        formStudentsId.splice(index, 1);
        formStudentsName.splice(index, 1);
        setStudentsForm(form);
        setSelectedStudentsId(formStudentsId);
        setSelectedStudentsName(formStudentsName);
    };

    const actionEditActivity = (index: number) => {
        const newTable = table.filter((_, idx) => index === idx);

        newTable.forEach((item) => {
            const items = {
                activity: item.activity,
                hour: item?.hour,
                detailing: item?.detailing || "",
                typeHour: item?.typeHour,
                dataVigenciaInicio: item.dataVigenciaInicio,
                dataVigenciaFim: item.dataVigenciaFim,
                campus: item?.campus,
                coverage: item?.coverage,
                students: item?.students,
                id: item?.id || null,
                workloadValid: item.workloadValid,
                hoursBookings: item.hoursBookings,
                tableIndex: item.tableIndex,
            };
            setCurrentActivity(items);
        });

        setIndexTable(index);

        setShowDialogEditActivity(true);
    };

    const handleRemoveActivity = (index: number) => {
        setIndexModal(index);
        setModalConfirm(true);
    };

    const actionsTable = (
        index: number,
        typeHour: any,
        workloadValid?: any
    ) => {
        const renderTooltipEdit = (props: any) => (
            <Tooltip {...props}>
                {pathLocation[1] === Routes.ConsultarPlano
                    ? "Visualizar"
                    : "Editar"}
            </Tooltip>
        );

        const renderTooltipRemove = (props: any) => (
            <Tooltip {...props}>Remover</Tooltip>
        );

        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <OverlayTrigger placement="auto" overlay={renderTooltipEdit}>
                    <StyledDefaultButtonLink
                        onClick={() => actionEditActivity(index)}
                        variant="link"
                    >
                        {pathLocation[1] === Routes.ConsultarPlano ? (
                            <ViewIcon style={{ fill: "#404040" }} />
                        ) : (
                            <EditIcon style={{ fill: "#404040" }} />
                        )}
                    </StyledDefaultButtonLink>
                </OverlayTrigger>

                <OverlayTrigger placement="auto" overlay={renderTooltipRemove}>
                    <StyledDefaultButtonLink
                        onClick={() => handleRemoveActivity(index)}
                        variant="link"
                        disabled={
                            pathLocation[1] === Routes.EditarPlano
                                ? false
                                : typeHour?.toLowerCase() !==
                                      TipoHoraEnumLabel.get(
                                          TipoHoraEnum.Normal
                                      )?.toLowerCase() ||
                                  workloadValid === true ||
                                  pathLocation[1] === Routes.ConsultarPlano
                        }
                    >
                        <DeleteIcon
                            style={{
                                fill: "#404040",
                            }}
                        />
                    </StyledDefaultButtonLink>
                </OverlayTrigger>
            </div>
        );
    };

    const restartPlanList = () => {
        setSelectPeriods("");
        setWorkLoadHours(selectTeachers);
        setIsCreatePlan(false);
        setTable([]);
        setHoursUsed(0);
        resetNewActivityForm();
        onChangeSelectTeachers();
        GenericUtils.restartScroll();
    };

    function getPlanToSave(
        rascunho: boolean,
        justificativa: string | undefined
    ) {
        const sanitizeReservaCargaHoraria = (hoursBookings: any) => {
            const reservaCargaHorariaId = hoursBookings?.reservaCargaHorariaId;
            if (!reservaCargaHorariaId) {
                return null;
            }

            return {
                reservaCargaHorariaId,
                contagemCargaHoraria:
                    hoursBookings?.contagemCargaHoraria ?? null,
            };
        };

        const planoAtividadeDocenteItems = table
            .map((data) => {
                const tipoHora = timeTypeResponse.find(
                    (select) =>
                        select.tipoHoraDescricao.toLowerCase() ===
                        data.typeHour.toLowerCase()
                );

                return {
                    planoAtividadeDocenteItemId: data.id ?? null,
                    atividade: {
                        atividadeId: data?.activity?.atividadeId,
                        codigoAtividade: data?.activity?.codigoAtividade,
                    },
                    cargaHoraria: data.hour,
                    abrangencia: data.coverage,
                    campus: data.campus,
                    atividadeDetalhamento: data.detailing,
                    tipoHora,
                    dataVigenciaInicio: data?.dataVigenciaInicio,
                    dataVigenciaFim: data?.dataVigenciaFim,
                    estudantes: data?.students?.filter(
                        (student: any) => student?.nome
                    ),
                    reservaCargaHoraria: sanitizeReservaCargaHoraria(
                        data?.hoursBookings
                    ),
                };
            })
            .map((item) =>
                // Remove undefined fields to keep payload aligned with backend DTOs.
                Object.fromEntries(
                    Object.entries(item).filter(
                        ([, value]) => value !== undefined
                    )
                )
            );

        return {
            id: teachingActivity?.id ?? null,
            contratoPadraoBase: teachingActivity?.contratoPadraoBase,
            letivaBase: teachingActivity?.letivaBase,
            naoLetivaBase: teachingActivity?.naoLetivaBase,
            horaLetivaEventual: teachingActivity?.horaLetivaEventual,
            horaNaoLetivaEventual: teachingActivity?.horaNaoLetivaEventual,
            horaLetivaSubstituicao: teachingActivity?.horaLetivaSubstituicao,
            horaNaoLetivaSubstituicao:
                teachingActivity?.horaNaoLetivaSubstituicao,
            cargaHorariaTotal: teachingActivity?.cargaHorariaTotal,
            horaNaoLetivaFlutuanteReservaBase:
                teachingActivity?.horaNaoLetivaFlutuanteReservaBase ??
                horaNaoLetivaFlutuanteReservaBase,
            horaNaoLetivaFlutuanteReservaEventual:
                teachingActivity?.horaNaoLetivaFlutuanteReservaEventual ??
                horaNaoLetivaFlutuanteReservaEventual,
            horaNaoLetivaFlutuanteReservaSubstituicao:
                teachingActivity?.horaNaoLetivaFlutuanteReservaSubstituicao ??
                horaNaoLetivaFlutuanteReservaSubstituicao,
            vigenciaPlanoAtividade: getPeriodsValidityValue[0] ?? validity,
            professor: selectTeachers,
            versao: "2",
            rascunho,
            dataVigenciaInicio: validaDataVigenciaInicioPlano(),
            dataVigenciaFim:
                finalDate ?? getPeriodsValidityValue[0]?.planoAtividadeDtFim,
            planoAtividadeStatusIdAtual: currentStatusActivityPlan ?? null,
            planoAtividadeStatusIdAnterior: previousStatusActivityPlan ?? null,
            planoAtividadeDocenteItems,
            justificativa,
        };
    }

    const actionSaveDraft = () => {
        const planToSave = getPlanToSave(true, "");

        postActivityPlans(planToSave).then((result: boolean) => {
            if (result) {
                setShowDialogDraft(true);
                getPeriods();
                restartPlanList();
            }
        });
    };

    function configureStudentsSelectByIdEvent(event: any, index: number) {
        try {
            const newArrayStudentsId = [...selectedStudentsId];
            const newArrayStudentsName = [...selectedStudentsName];
            const eventValueId = event;

            const eventValueName = [
                {
                    label: event[0]?.value || "",
                    value: event[0]?.label || "",
                    studentId: event[0]?.studentId || "",
                },
            ];
            newArrayStudentsId[index] = eventValueId;
            newArrayStudentsName[index] = eventValueName;

            setSelectedStudentsId(newArrayStudentsId);
            setSelectedStudentsName(newArrayStudentsName);

            const getStudent = getStudentsValue.filter(
                (studentValue) => studentValue.nome === event[0]?.value
            );
            const newArray = [...studentsForm];
            [newArray[index]] = getStudent;
            if (getStudent.length > 0) {
                setStudentsForm(newArray);
            }
            // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }

    function configureStudentsSelectByNameEvent(event: any, index: number) {
        try {
            const newArrayStudentsName = [...selectedStudentsName];
            const newArrayStudentsId = [...selectedStudentsId];
            const eventValueName = event;

            const eventValueId = [
                {
                    value: event[0]?.label || "",
                    label: event[0]?.value || "",
                    studentId: event[0]?.studentId || "",
                },
            ];
            newArrayStudentsName[index] = eventValueName;
            newArrayStudentsId[index] = eventValueId;

            setSelectedStudentsName(newArrayStudentsName);
            setSelectedStudentsId(newArrayStudentsId);

            const getStudent = getStudentsValue.filter(
                (studentValue) => studentValue.nome === event[0]?.label
            );

            const newArray = [...studentsForm];
            const studentsArray = getStudent[0];
            newArray[index] = studentsArray;
            if (studentsArray) {
                setStudentsForm(newArray);
            }
            // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }

    useEffect(() => {
        let StudentsFormFullFilledValue = selectedStudentsName.length !== 0;
        studentsForm.forEach((value) => {
            if (value?.cpf === "") {
                StudentsFormFullFilledValue = false;
            }
        });
        setStudentsFormFullFilled(StudentsFormFullFilledValue);
    }, [studentsForm]);

    function checkStudentExistsInLocalAcitivityPlan(paramValid: {
        estudanteId: any;
        atividadeId: any;
        campus: any;
        docenteId: any;
        abrangencia: any;
        vigenciaId: string;
    }) {
        let valid = false;

        const matchingStudentArray = selectedStudentsId.find((studentArray) =>
            studentArray.some(
                (student: any) => paramValid.estudanteId === student.studentId
            )
        );

        if (matchingStudentArray) {
            const matchingStudent = matchingStudentArray.find(
                (student: any) => paramValid.estudanteId === student.studentId
            );

            if (matchingStudent) {
                const studentName = matchingStudent.value;
                actionShowModalError(
                    `O estudante ${studentName} já está vinculado à essa atividade neste TACH.`
                );
                valid = true;
            }
        }

        return valid;
    }

    const validStudentUse = (index: number, selectedStudent: any) => {
        const cpf = selectedStudent.at(0)?.value;
        const newTable = [...table];
        const studentsBlank = studentsForm.filter((student) => student?.nome);
        const obj = {
            activity: selectActivity,
            coverage: selectCoverage,
            detailing: textArea,
            hour: selectNumberHours,
            students: studentsBlank,
            typeHour: timeTypeResponse.find(
                (select) => select.tipoHoraId === TipoHoraEnum.Normal
            )?.tipoHoraDescricao,
            campus: selectCampus,
            tableIndex: newTable.length,
        };
        if (!cpf) {
            return;
        }
        const findStudent = getStudentsValue.find((value) => value.cpf === cpf);

        const valid = validItem(newTable, obj);

        const paramValid = {
            estudanteId: findStudent.estudanteId,
            atividadeId: selectActivity?.atividadeId,
            campus: selectCampus,
            abrangencia: selectCoverage?.nome,
            vigenciaId: selectedPeriod,
            docenteId: selectTeachers?.docenteID,
        };
        putStudentValidate(paramValid).then((result) => {
            if (!result) {
                configureStudentsSelectByIdEvent(
                    [{ value: "", label: "", studentId: "" }],
                    index
                );
                configureStudentsSelectByNameEvent(
                    [{ value: "", label: "", studentId: "" }],
                    index
                );
            } else {
                const existsInPlan = checkStudentExistsInLocalAcitivityPlan(
                    paramValid || valid
                );
                if (existsInPlan) {
                    configureStudentsSelectByIdEvent(
                        [{ value: "", label: "", studentId: "" }],
                        index
                    );
                    configureStudentsSelectByNameEvent(
                        [{ value: "", label: "", studentId: "" }],
                        index
                    );
                } else {
                    configureStudentsSelectByIdEvent(selectedStudent, index);

                    configureStudentsSelectByNameEvent(selectedStudent, index);
                }
            }
        });
    };

    const handleStudentsName = (event: any, index: number) => {
        if (
            selectedStudentsId.some((item) => item.label === event.at(0)?.label)
        ) {
            setModalErrorStudentAssociado(true);
            const newArrayStudentsName = [...selectedStudentsName];
            const newArrayStudentsId = [...selectedStudentsId];
            newArrayStudentsName[index] = [];
            newArrayStudentsId[index] = [];
            setSelectedStudentsName(newArrayStudentsName);
            setSelectedStudentsId(newArrayStudentsId);
            return;
        }

        if (event.at(0)?.label) validStudentUse(index, event);
    };

    const handleStudentsId = (event: any, index: number) => {
        /**
         * Quando eu apago um caracter o array vem vazio
         * o Index sempre é 0
         */
        const modifyEvent = [
            {
                value: event[0]?.label || "",
                label: event[0]?.value || "",
                studentId: event[0]?.studentId || "",
            },
        ];

        if (
            selectedStudentsId.some((item) => item.label === event.at(0)?.label)
        ) {
            setModalErrorStudentAssociado(true);
            const newArrayStudentsName = [...selectedStudentsName];
            const newArrayStudentsId = [...selectedStudentsId];
            newArrayStudentsName[index] = [];
            newArrayStudentsId[index] = [];
            setSelectedStudentsName(newArrayStudentsName);
            setSelectedStudentsId(newArrayStudentsId);
            return;
        }

        if (modifyEvent.at(0)?.value) validStudentUse(index, modifyEvent);
    };

    const tableContainer = () => {
        const styleContainer =
            isConsultProfile && !isMyConsultProfile
                ? {
                      background: "#FFFFFF",
                      border: "1px solid #E4E4E4",
                      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
                      borderRadius: "8px",
                  }
                : {};

        const styleTable =
            isConsultProfile && !isMyConsultProfile
                ? {
                      tableConsultProfileStyles,
                      background: "#F0F2F2",
                  }
                : {
                      tableConsultProfileStyles,
                      background: "#FFFFFF",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)",
                  };
        return (
            <div style={styleContainer} className="mt-5">
                <StyledTopActivityCard>
                    <div style={{ paddingLeft: "24px" }}>
                        <StyledTitlePlan style={{ paddingBottom: "0px" }}>
                            Carga Horária Não Letiva/Permanência Alocada
                        </StyledTitlePlan>
                        <StyledSubTitle
                            style={{ color: "#9654FF", marginTop: "8px" }}
                        >
                            {hoursUsed} h/a utilizadas
                        </StyledSubTitle>
                    </div>
                    <StyledDefaultButtonLink
                        onClick={actionShowTableActivity}
                        variant="link"
                    >
                        {showTableActivities ? <ExpandIcon /> : <RecallIcon />}
                    </StyledDefaultButtonLink>
                </StyledTopActivityCard>
                {showTableActivities && (
                    <div style={styleTable}>
                        <Table style={{ marginBottom: 0 }} striped>
                            <thead
                                style={{
                                    backgroundColor: "#E4E4E4",
                                    fontSize: "14px",
                                    borderWidth: "1px",
                                    textAlign: "center",
                                }}
                            >
                                <tr>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Atividade
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            <div style={{ width: 100 }}>
                                                Tipo de hora
                                            </div>
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Hora/aula
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Escola/Curso
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Estudante
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Detalhamento
                                        </StyledTableActivityDiv>
                                    </th>
                                    <th>
                                        <StyledTableActivityDiv>
                                            Ações
                                        </StyledTableActivityDiv>
                                    </th>
                                </tr>
                            </thead>
                            <tbody
                                style={{
                                    borderWidth: "1px",
                                    background: "none",
                                }}
                            >
                                {table.map((item, index) => (
                                    <tr
                                        key={`table-${index.toString()}`}
                                        style={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <StyledTableActivityTd>
                                            {item?.activity
                                                ?.descricaoAtividade || ""}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd>
                                            {item?.typeHour}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd
                                            style={{ minWidth: "100px" }}
                                        >
                                            {item?.hour}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd>
                                            {item?.coverage?.nome}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd>
                                            {item?.activity?.temEstudante ===
                                            "S"
                                                ? "Sim"
                                                : "Não"}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd>
                                            {item?.detailing}
                                        </StyledTableActivityTd>
                                        <StyledTableActivityTd>
                                            {actionsTable(
                                                index,
                                                item?.typeHour,
                                                item?.workloadValid
                                            )}
                                        </StyledTableActivityTd>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        );
    };

    const tableView = tableContainer();

    async function savePlan(justificativa = "") {
        const planToSave = getPlanToSave(false, justificativa);

        postActivityPlans(planToSave).then((result: boolean) => {
            if (result) {
                setShowDialogActivityPlanSendToAprove(true);
                setSelectPeriods("");
                onChangeSelectTeachers();
                setModalJustify(false);
            }
        });
    }

    const actionSendToAprove = async () => {
        if (isApprovalDisabled) {
            return;
        }

        if (pathLocation[1] !== Routes.MeuPlano) {
            setModalJustify(true);
        } else {
            savePlan();
        }
    };

    const clearSelectedData = () => {
        setSelected([]);
        setActivityPlan([]);
        setWorkloadHistoricExtraData(initialWorkloadHistoricExtraData);
        setSelectTeachers(undefined);
        getActiveTeachersByLocation(pathLocation[1]);
    };

    // eslint-disable-next-line @typescript-eslint/ban-types
    const renderConfirmationDialog = (callback: Function) => {
        if (
            // eslint-disable-next-line no-restricted-globals, no-alert
            confirm(promptMessage) === true
        ) {
            callback();
        }
    };

    const onAutoCompleteChange = (valueSelected: any) => {
        if (
            (valueSelected.length >= 1 && selected.length === 0) ||
            pathLocation[1] === Routes.ConsultarPlano
        ) {
            setSelected(valueSelected);
        }

        if (
            valueSelected.length === 0 &&
            pathLocation[1] !== Routes.ConsultarPlano
        ) {
            renderConfirmationDialog(() => clearSelectedData());
        }
    };

    const handleAutoCompleteClearButtonClicked = () => {
        if (pathLocation[1] !== Routes.ConsultarPlano) {
            renderConfirmationDialog(() => clearSelectedData());
            return;
        }

        clearSelectedData();
    };

    const DialogJustifyPlan = (
        <ModalJustifyPlan
            open={modalJustify}
            onClose={() => {
                setModalJustify(false);
            }}
            onSave={async (value: any) => {
                savePlan(value);
            }}
        />
    );

    const DialogSucessEdit = (
        <Dialog
            openModal={modalSucess}
            onHide={() => {
                setModalSucess(false);
            }}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>Ação realizada com sucesso!</StyledModalTitle>

            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={() => {
                    setModalSucess(false);
                }}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const DialogEndTachFail = (
        <Dialog
            openModal={error.hasError}
            onHide={() => {
                setError({
                    hasError: false,
                    message: "",
                    title: "",
                });
            }}
            modalIcon={<SuccessModal />}
        >
            <StyledModalTitle>{error.title}</StyledModalTitle>
            <StyledModalText>{error.message}</StyledModalText>

            <StyledImportButton
                style={{ width: 84, marginTop: 24 }}
                onClick={() => {
                    setError({
                        hasError: false,
                        message: "",
                        title: "",
                    });
                }}
            >
                OK
            </StyledImportButton>
        </Dialog>
    );

    const selectingAProfessor = (
        <StyledSelectTeacherDiv>
            <div className="selectTeacher" style={{ display: "flex" }}>
                <Autocomplete
                    onChange={onAutoCompleteChange}
                    options={teachers}
                    placeholder="Selecionar professor"
                    selected={selected}
                    extraOptions
                    customClearFunction={handleAutoCompleteClearButtonClicked}
                />
            </div>
        </StyledSelectTeacherDiv>
    );

    const cardInformationProfessor = selectTeachers && (
        <StyledCard body className="mt-4">
            <div>
                <StyledCardTitle>Professor</StyledCardTitle>
            </div>
            <div>
                <StyledCardTeacher>
                    {`${selectTeachers.nome} - ${selectTeachers.matriculaAdp}`}
                </StyledCardTeacher>
            </div>
            <Row className="align-items-center">
                <Col xs="12" sm="12" lg="8" className="mt-3">
                    <StyledCardHour>
                        {isCreatePlan
                            ? "Carga Horária Não Letiva/Permanência a ser distribuída:"
                            : "Carga Horária Não Letiva/Permanência:"}
                    </StyledCardHour>
                    <StyledCardAvailableHours
                        style={{
                            background: getWorkloadBadgeColor(),
                        }}
                    >
                        {`${workloadBase} h/a`}
                    </StyledCardAvailableHours>
                </Col>
                <Col xs="12" sm="12" lg="4" className="mt-3 mt-xs-4">
                    <Row className="float-end float-xs-center float-sm-center">
                        {pathLocation[1] !== Routes.ConsultarPlano && (
                            <BtnOutlinePrimary
                                onClick={actionCreateActivityPlan}
                                style={{
                                    width: "110px",
                                    marginRight: "10px",
                                }}
                                disabled={
                                    isCreatePlan ||
                                    (pathLocation[1] === Routes.MeuPlano &&
                                        isBlockPeriod) ||
                                    GenericUtils.validaAfastamentoDocente(
                                        selectTeachers
                                    ) ||
                                    disabledCriarTach
                                }
                            >
                                Criar
                            </BtnOutlinePrimary>
                        )}
                        <BtnOutlinePrimary
                            onClick={actionShowWorkload}
                            style={{
                                width: "160px",
                            }}
                        >
                            Ver carga horária
                        </BtnOutlinePrimary>
                    </Row>
                </Col>
            </Row>
        </StyledCard>
    );

    const creatingActivityPlanForm = (
        <>
            <StyledFlexDivWithGap>
                <AutoCompleteClean
                    onChange={setSelectedActivity}
                    options={activities}
                    placeholder="Atividade"
                    selected={selectedActivity}
                    style={{ width: "100%" }}
                />
                <InputSelect
                    optionsSelect={timeType}
                    handleSelectChange={handleTimeSelectChange}
                    value={selectTimeType}
                    style={disabledInputTypeHourStyle}
                    disabled
                />
                <InputSelect
                    optionsSelect={numberHours}
                    handleSelectChange={handleNumbersSelectChange}
                    value={selectNumberHours}
                    style={inputNumberHourStyles({})}
                />
            </StyledFlexDivWithGap>
            <StyledFlexDivWithGap style={{ marginBottom: "24px" }}>
                <AutoCompleteClean
                    onChange={setSelectedCampus}
                    options={campus}
                    placeholder="Campus"
                    selected={selectedCampus}
                    style={{ width: "200px" }}
                    disabled={!selectActivity}
                />
                <AutoCompleteClean
                    onChange={setSelectedCoverage}
                    options={covegage}
                    placeholder="Escola/Curso"
                    selected={selectedCoverage}
                    disabled={!selectCampus}
                    style={{ width: "100%" }}
                />
            </StyledFlexDivWithGap>
        </>
    );

    const studentsInfoForm = studentsForm.map((student, index) => (
        <div key={student.matricula} style={{ display: "flex" }}>
            <AutoCompleteClean
                onChange={(e) => handleStudentsId(e, index)}
                options={studentsId}
                placeholder="CPF/Passaporte"
                selected={selectedStudentsId[index]}
                extraOptions
                extraLabel="Nome"
                disabled={!selectCoverage}
                style={{ marginRight: "14px", width: "600px" }}
            />
            <AutoCompleteClean
                onChange={(e) => handleStudentsName(e, index)}
                options={studentsName}
                placeholder="Estudante"
                selected={selectedStudentsName[index]}
                extraOptions
                extraLabel="CPF/Passaporte"
                disabled={!selectCoverage}
                style={{
                    width: "100%",
                    marginBottom: "24px",
                }}
            />
            {studentsFormFullFilled && studentsForm.length - 1 === index && (
                <StyledDefaultButtonLink
                    onClick={() => actionFormStudentsAdd()}
                    variant="link"
                >
                    <PlusIcon />
                </StyledDefaultButtonLink>
            )}
            {index >= 0 && (
                <StyledDefaultButtonLink
                    onClick={() => actionFormStudentsDelete(index)}
                    variant="link"
                >
                    <LessIcon />
                </StyledDefaultButtonLink>
            )}
        </div>
    ));

    const activityPlanCreated = (
        <div className="mt-5">
            <StyledTitlePlan>TACHs criados</StyledTitlePlan>
            {activityPlan.length ? (
                <div
                    style={{
                        display: "grid",
                        gap: 16,
                        gridTemplateColumns: "1fr 1fr",
                    }}
                >
                    {activityPlanCard}
                </div>
            ) : (
                <StyledInformationPlanNotFound style={{ display: "flex" }}>
                    <InformationIcon style={{ fill: "#404040" }} />
                    <StyledTextPlan>Não há TACH criado.</StyledTextPlan>
                </StyledInformationPlanNotFound>
            )}
        </div>
    );

    return (
        <ThemeProvider theme={theme}>
            <AcademicActivityPlanHeader />
            <StyledBody>
                {(pathLocation[1] === Routes.EditarPlano ||
                    pathLocation[1] === Routes.ConsultarPlano) &&
                    selectingAProfessor}

                {cardInformationProfessor}
                {selectTeachers && isValidCreatePlan ? (
                    <>
                        <StyledCard body className="mt-5">
                            {pathLocation[1] === Routes.ConsultarPlano ? (
                                tableView
                            ) : (
                                <>
                                    <StyledTitlePlan>
                                        {editTach
                                            ? "Editar TACH"
                                            : "Criar TACH"}
                                    </StyledTitlePlan>
                                    <StyledSemesterDiv>
                                        <StyledSemesterParagraph>
                                            Semestre
                                        </StyledSemesterParagraph>
                                        {getPeriodsValue[0].text}
                                    </StyledSemesterDiv>
                                    {creatingActivityPlanForm}
                                    {isStudents && studentsInfoForm}
                                    <div>
                                        <InputLabelTextArea
                                            placeholder="Detalhamento - Este campo é preenchido automaticamente."
                                            value={textArea}
                                            maxLength={500}
                                            viewLengthInfo
                                            clear
                                            onChange={handleTextAreaChange}
                                            style={{ height: "48px" }}
                                            disabled={
                                                mandatoryDetailing === "S" &&
                                                textArea.length > 0 &&
                                                textArea ===
                                                    selectActivity?.atividadeDetalhamentoDescricao
                                            }
                                        />
                                    </div>
                                    <div>
                                        <BtnOutlinePrimary
                                            onClick={actionCreateActivity}
                                            style={{ width: 190 }}
                                            disabled={isValid()}
                                        >
                                            <CheckIcon />
                                            Incluir Atividade
                                        </BtnOutlinePrimary>
                                    </div>

                                    {tableView}
                                    <Row className="ms-1 mt-5 mb-3">
                                        <BtnOutlinePrimary
                                            className="me-4"
                                            onClick={actionSaveDraft}
                                            style={{ width: 190 }}
                                            disabled={editTach}
                                        >
                                            Salvar Rascunho
                                        </BtnOutlinePrimary>
                                        <BtnPrimary
                                            disabled={isApprovalDisabled}
                                            style={{ width: 220 }}
                                            onClick={actionSendToAprove}
                                        >
                                            Enviar para aprovação
                                        </BtnPrimary>
                                    </Row>
                                </>
                            )}
                            {showTableTachHistoric && (
                                <div className="mt-5">
                                    <StyledTopActivityCard>
                                        <StyledPaddingLeft>
                                            <StyledTitlePlan padding={0}>
                                                Histórico de Aprovações
                                            </StyledTitlePlan>
                                        </StyledPaddingLeft>
                                        <StyledDefaultButtonLink
                                            onClick={actionShowTableHistoric}
                                            variant="link"
                                        >
                                            {showTableHistoric ? (
                                                <ExpandIcon />
                                            ) : (
                                                <RecallIcon />
                                            )}
                                        </StyledDefaultButtonLink>
                                    </StyledTopActivityCard>
                                    {showTableHistoric && (
                                        <div>
                                            <AcademicActivityPlanHistoric
                                                teachingActivityPlanId={
                                                    workloadHistoricExtraData.planoAtividadeDocenteId
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </StyledCard>
                        <Row className="mt-5">
                            <Col>
                                <BtnOutlinePrimary
                                    style={{ width: 140 }}
                                    onClick={() => {
                                        renderConfirmationDialog(
                                            restartPlanList
                                        );
                                    }}
                                >
                                    Voltar
                                </BtnOutlinePrimary>
                            </Col>
                        </Row>
                    </>
                ) : (
                    selectTeachers && activityPlanCreated
                )}
            </StyledBody>
            {showDialogTachHistoric && modalAcademicActivityPlanHistoric}
            {DialogCreateActivityPlan}
            {DialogWorkload}
            {DialogActivityIncluded}
            {DialogNoHours}
            {DialogActivityEdit}
            {DialogActivityRemoved}
            {DialogActivityPlanSendToAprove}
            {DialogDraft}
            {DialogError}
            {DialogErrorMessage}
            {DialogConfirmRemoveActitivy}
            {DialogJustifyPlan}
            {modalDetailsAcademicActivityPlan}
            {DialogSucessEdit}
            {showDialogJustifyEndTach && justifyEndTachModal}
            {error.hasError && DialogEndTachFail}
            {modalAcademicActivityPlanEndPlanHistoricProps.open &&
                modalAcademicActivityPlanEndHistoric}
            <Prompt
                when={isCreatePlan || selected.length > 0}
                message={promptMessage}
            />
        </ThemeProvider>
    );
}

export default AcademicActivityPlan;
